export default {
  services: {
    hero: {
      title: "Gagnez du temps pour faire plus",
      paragraph:
        "Découvrez quelques-uns de nos centaines de clients professionnels qui bénéficient de projetsolaire.com au quotidien. Pourquoi pas vous ?",
      "button-1": "Demander une démo",
      "button-2": "Démarrer maintenant",
    },
    "value-proposition": {
      "everything-you-need": "Vos besoins - Nos idées - Votre solution",
      title: "Plateforme de gestion de chantiers sur web & mobile",
      paragraph:
        "Le photovoltaïque ne devrait pas être si compliqué. Développez votre activité avec un outil informatique qui simplifie chaque étape de vos projets solaires.",
      "key-value": {
        "team-management": {
          title: "Gestion d'équipe",
          description: "et chantiers.",
        },
        "digital-presentations": {
          title: "Gestion d'agenda",
          description: "intégrée.",
        },
        administration: {
          title: "Gestion du matériel",
          description: "avec cahiers de charges.",
        },
        "quotes-management": {
          title: "Paiements sécurisés",
          description: "par virement bancaire.",
        },
        "hardware-management": {
          title: "Signatures électroniques",
          description: "conformes.",
        },
        "calendar-management": {
          title: "Notifications email",
          description: "automatiques et réglables.",
        },
      },
    },
    stats: {
      "key-numbers": "Chiffres clés",
      title: "Renforcer votre équipe pour grandir",
      paragraph:
        "Notre équipe est composée de spécialistes de l’énergie solaire et d'informaticiens, qui travaillent côte à côte avec les artisans du photovoltaïque afin de leurs proposer des solutions informatiques de pointe qui répondent à leurs besoins.",
      "number-stats": {
        "founded-in": {
          stat: "2020",
          emphasis: "Fondée",
          rest: "lors du premier confinement.",
        },
        "installer-on-platform": {
          stat: "600+",
          emphasis: "Entreprises locales",
          rest: "avec nous.",
        },
        servicing: {
          stat: "5000+",
          emphasis: "Projets solaires",
          rest: "rendus possibles.",
        },
        "projects-in-france": {
          stat: "100+ MW",
          emphasis: "Chantiers",
          rest: "en ligne.",
        },
      },
    },
    testimonials: {},
    "service-block": {
      title: "Solutions informatiques à la carte sans abonnement",
      description:
        "Explorez comment croître votre activité tout en gagnant du temps.",
      services: {
        "meet-new-customers": "Découvrir de nouveaux clients",
        "automate-administration": "Automatiser le processus administratif",
        "explore-digital": "Explorez le numérique",
      },
    },
    commitments: {
      "why-us": "L'informatique au service du photovoltaïque",
      title: "Nos engagements",
      paragraph:
        "La France est le seul pays en Europe qui a installé moins de kW de panneaux solaires cette année que l’année dernière. Les délais dus aux démarches administratives se comptent en plusieurs mois. Le progrès technique fait qu’une démarche de rupture est nécessaire. Nous aidons l'artisanat de France à gagner du temps pour mieux croître.",
      "key-values": {
        value1: {
          title:
            "Faciliter aux professionnels techniques l’exercice de leur cœur de métier.",
          description: "",
        },
        value2: {
          title:
            "Libérer enfin la filière photovoltaïque de l’éco-délinquance.",
          description: "",
        },
        value3: {
          title:
            "Proposer les services numériques de pointe aux artisans pour réduire leurs délais ainsi que coûts de commercialisation.",
          description: "",
        },
        value4: {
          title:
            "Renforcer l’indépendance de la filière par rapport aux grands groupes de sous-traitance et des plateformes contraignantes",
          description: ".",
        },
        value5: {
          title:
            "Valoriser les entreprises locales et le savoir-faire de proximité.",
          description: "",
        },
        value6: {
          title: "Réduire la fracture numérique qui se creuse dans notre pays.",
          description: "",
        },
      },
    },

    cta: {
      "start-using":
        "Simplifiez enfin la gestion de vos projets solaires dès aujourd'hui.",
      paragraph:
        "Utiliser notre outil informatique est aussi simple que d'envoyer un e-mail. Accélérez la croissance de votre activité en maîtrisant chacun de vos projets solaires.",
      button: "Essayer maintenant",
      "learn-more": "En savoir plus",
      "case-studies": "Découvrez les avis de nos clients",
    },
  },
  "find-new-clients": {
    hero: {
      "discover-new-clients": {
        title: "Recevez des chantiers, envoyez vos devis",
        paragraph:
          "Découvrez un modèle économique innovant d'assistance de maîtrise d'ouvrage. Sans commissions d'apporteur d'affaires. Aucune sous-traitance.",
        "button-1": "En savoir plus",
        "button-2": "Démarrer",
      },
    },
    process: {
      step1: {
        title: "Activez votre compte",
        description:
          "Afin de garantir la confiance des propriétaires envers la filière photovoltaïque, vous devrez soumettre vos labels et documents juridiques.",
      },
      step2: {
        title: "Feuilletez les opportunités",
        description:
          "Soumettez votre proposition sans frais. Vous choisissez le matériel ; le prix aussi. L'utilisateur reste anonyme jusqu'à son choix du maître d’œuvre.",
      },
      step3: {
        title: "Réalisez la visite technique",
        description:
          "Rencontrez l'utilisateur quand il sera prêt à investir. La faisabilité du chantier sera validée lors de la visite technique obligatoire sur site.",
      },
      step4: {
        title: "Soumettez votre devis définitif",
        description:
          "Percevez vos revenus automatiquement dès la signature électronique : le service n'est facturé qu'au règlement de l'acompte.",
      },
    },
    features: {
      "search-local-area": {
        title: "Trouvez des chantiers en ligne",
        paragraph:
          "L'utilisateur définit le cahier de charges qui correspondra au mieux à l'orientation énergétique de son projet solaire. L’utilisateur est accompagné dans son choix grâce à notre étude technico-financière de son installation photovoltaïque. Celle-ci inclut l’évaluation au kWh/m² de l’ensoleillement ainsi que l'analyse horaire de la courbe de charge sur site.",
        button: "En savoir plus",
      },

      "use-your-hardware": {
        title: "Vous choisissez le matériel",
        paragraph:
          "Prenez connaissance du cahier des charges de l'utilisateur pour personnaliser au mieux votre proposition photovoltaïque. Renseignez votre matériel. Vous validerez vous-même la faisabilité du chantier lors de la visite technique obligatoire sur place.",
        button: "",
      },

      "submit-custom-quotes": {
        title: "Chiffrez votre prix",
        paragraph:
          "Fixez librement votre prix et votre acompte en soumettant votre proposition avec votre matériel, prestations et tarifs. Détaillez le profil public de votre établissement. Seule l’entreprise retenue par l’utilisateur à le droit de le contacter. Vous pouvez ainsi rencontrer l’utilisateur en personne dès la visite technique.",
        button: "",
      },

      pricing: {
        title: "Recevez des chantiers clés en main",
        paragraph:
          "Faites-vous payer automatiquement par virement bancaire en ligne. Le service est facturé que quand vous êtes payé : si vous gagnez 0 € pour un mois donné, notre service vous sera gratuit pour ce mois-ci. Les frais de service incluts la réalisation des démarches administratives, financières et assurancielles.",
        button: "",
      },

      "manage-the-projects-you-won": {
        title: "Concentrez-vous sur l'essentiel",
        paragraph:
          "Bénéficiez d’une plateforme intégrée avec signatures électroniques, paiements sécurisés, planification de chantiers et d’autres fonctionnalités d’automatisation. Nos pages de paiement prêtes à l’emploi s'intègrent dans vos méthodes de facturation, pour une expérience de paiement améliorée. Suivez ainsi les agendas, planifiez les visites, et pilotez le chantier à distance via notre tableau de bord simplifié.",
        button: "",
      },
    },
    pricing: {
      title: "Quel prix du watt-crête ?",
      paragraph:
        "Les frais du service d'assistance de maîtrise d'ouvrage reposent sur les prix au watts-crêtes que vous pratiquez. Aucun frais tant que vous ne percevez pas de revenus.",
      "on-card": {
        title: "Une tarification triplement gagnante",
        paragraph:
          "Un pourcentage du montant HT est prélevé en fonction des revenus générées à travers notre plateforme. Ce pourcentage varie en fonction du prix du watt-crête de chaque devis.  Plus vous êtes compétitif, moins vous payez.",
        "what-included": "Réduire les coûts annexes",
        items: {
          item1: "Ne payez aucune commission de vente.",
          item2: "Gain de temps sur les déplacements prématurés évitées.",
          item3:
            "Plus de frais de réalisation des démarches administratives grâce à la gestion dématérialisation.",
        },
        "pay-win": "Méthode de calcul du pourcentage",
        "price-1": "€ / Wc",
        "price-2": "x 0,04",
        button: "En savoir plus",
        "little-line": "Pourcentage prélevé sur le montant HT.",
      },
    },
    cta: {
      //redo
      title: "Simplifiez la gestion de vos projets solaires aujourd'hui",
      paragraph:
        "Si vous savez comment envoyer un e-mail, vous savez déjà utiliser notre outil informatique. Accélérer la croissance de votre activité.",
      "button-1": "Démarrer maintenant",
      "button-2": "Documentation",
    },

    // Not in the page anymore //
    contact: {
      "contact-hero": {
        title: "Contactez-nous",
        paragraph:
          "Vel nunc non ut montes, viverra tempor. Proin lectus nibh phasellus morbi non morbi. In elementum urna ut volutpat. Sagittis et vel et fermentum amet consequat.",
      },
      "contact-form": {},
    },
    // Not in the page anymore //
  },
  "sales-widget": {
    "beat-competition": "Devancer ma concurrence",
    "sign-up": "Inscription",
    "title-first-half": "Bureau d'études",
    "title-second-half": "pensé pour la vitesse",
    subtitle:
      "projetsolaire : le N°1 de gestion de chantiers pour les artisans, installateurs, développeurs du photovoltaïque.",
    "pv-magazine-citation":
      "« Il est possible de réaliser toutes les étapes d’une installation solaire collaborativement sur le même outil informatique »",
    "trusted-by": "Ils nous font confiance",
    "ask-demo": "Demander une démo",
    presentations: "Études de cas",
    button: "Découvrir maintenant",
    join: "Déjà 575 entreprises",
    "you-should-earn": "Vous pourriez gagner",
    "gain-time": "Gagnez du temps avec projetsolaire",
    for: "pour",
    "projects-per-month": "chantiers par mois",
    "per-month": "par mois",
    hours: "heures",
    discount: "avec une réduction de %{discount} € par chantier",
    "how-cost-estimates-are-calculated": {
      button: "Découvrez comment nous estimons vos charges",
      title: "Comment vos estimations de coûts sont-elles calculées ?",
    },
    "hours-per-project": "%{hours} heures par dossier complet",
    "open-project-modal": {
      title: "Combien de chantiers par mois ?",
    },
    "open-charges-modal": {
      title: "Comment vos estimations de coûts sont-elles calculées ?",
      content:
        "<p>Pour estimer votre réduction des charges de votre bureautique, nous examinons le délais moyen de traitement des dossiers sur l’ensemble du cycle de vente des entreprises similaires à la votre. Le bureau d’études numérique de projetsolaire traite des milliers de dossiers par mois auprès de <a class='text-blue-600 underline' target='_blank' href='https://www.projetsolaire.com/installer/case-studies'>centaines</a> d’entreprises du photovoltaïque. </p> <p> Nous calculons vos charges à partir des informations que vous indiquez concernant votre activité. Vous nous indiquez votre nombre de chantiers par mois. Si vous précisez le délai moyen de traitement par dossier vous obtiendrez une estimation plus précise pour vous, calculée en fonction de votre nombre d’heures de traitement de votre cycle de vente.</p><p> En France, plus de la moitié du montant d’un devis photovoltaïque ne correspond pas au coût du matériel. Les charges liées à la masse salariale hors main d’oeuvre contribuent largement au coût du watt-crête. Nous obtenons les moyennes de l’INSEE pour déterminer le salaire horaire de votre bureautique. Les montants de la catégorie <a class='text-blue-600 underline' target='_blank' href='https://www.insee.fr/fr/metadonnees/pcs2003/categorieSocioprofessionnelleAgregee/5?champRecherche=false' >« Employés »</a> de l’INSEE sont utilisés. Le salaire mensuel moyen de la catégorie employés en France est de 2 433 € brut par mois <a class='text-blue-600 underline' target='_blank' href='https://www.insee.fr/fr/statistiques/7707884#onglet-2' >(INSEE, 2022)</a >. La moyenne des heures de travail de la catégorie employés est de 1 603 heures par an <a class='text-blue-600 underline' target='_blank' href='https://www.insee.fr/fr/statistiques/7456897?sommaire=7456956' >(INSEE, 2022)</a >, soit 133 heures par mois. Le taux horaire, hors charges patronales et sociales, est de 18,39 € par heure. Ce montant représente le coût horaire de votre bureautique. Ce coût se répercute sur votre coût au watt-crête et ainsi sur vos devis. </p> <p> Sur cette base, nous estimons votre coût par chantier sans projetsolaire. Puis, nous multiplions ce coût par chantier avec votre nombre de chantiers. </p> <p> La réduction réelle de vos charges dépendra de plusieurs facteurs, dont votre nombre de chantiers, les puissances photovoltaïques de celles-ci, la durée réelle de traitement de vos dossiers, et votre utilisation des prestations à la carte de projetsolaire. Votre coût horaire de traitement dépend aussi du salaire exacte de votre pôle administratif dans votre entreprise. </p><p>Ces estimations de votre réduction des charges de votre bureautiquene sont pas une évaluation ou une promesse ; estimations à titreindicatives sans valeur contractuelle.</p>",
    },
    "open-config-modal": {
      title: "Parlez-nous de votre bureautique",
      subtitle: "Puissance des installations",
      residentialProject: "Chantiers résidentiels",
      businessProject: "Chantiers tertiaires",
      form: {
        "form-description": "Délai moyen de traitement par dossier",
        "form-subdescription":
          "Renseignez le nombre moyen d'heures par chantier.",
        "sale-time": {
          label: "Prospection, déplacements et RDV",
          description:
            "Préparation des documents d’études, déplacements non conclusifs, réalisation puis modifications des offres, suivi des prospects, et ventes.",
        },
        "admin-time": {
          label: "Envoi et suivi administratif (sur 2 mois)",
          description:
            "Préparation des documents graphiques et techniques, envoi des dossiers, traitement des demandes de pièces complémentaires, et relances.",
        },
        "crm-time": {
          label: "Bureautique, ADV et service client",
          description:
            "Suivi des dossiers, répondre aux appels entrants après vente, l'organisation et la synchronisation des fichiers et informations au travers plusieurs logiciels.",
        },
      },
    },
    "update-estimate": "Mettre à jour mon estimation",
    "data-not-saved": "Information non sauvegardée",
    "information-not-saved": "Informations non stockées",
    card: {
      title: "Devancez votre concurrence",
      presentation: "Étude et devis",
      administration: "Administratif",
      facturation: "Facturation et suivi",
      button: "Témoignages",
    },
  },
  "enhanced-testimonials": {
    "case-studies-badge": "Clients par taille",
    title:
      "Entreprises de toutes tailles utilisent projetsolaire.com partout en France",
    type: {
      small: "Artisan",
      medium: "Croissance",
      national: "Acteurs nationaux",
      developer: "Développeur",
    },
    "administration-badge":
      "Découvrez les témoignages clients. Ce sont eux qui en parlent le mieux !",
    product: {
      label: "Produits utilisés",
      products: {
        sales_solutions: "Génération leads",
        design: "Dimensionnement",
        platform: "Gestion équipe gratuite",
        permitting: "Urbanisme",
        integrated_financing: "Financement",
        grid: "Raccordement et Consuel",
        hardware: "Gestion du matériel",
      },
    },
  },
  administration: {
    hero: {
      administration: {
        title: "Administratif automatisée",
        paragraph:
          "Évitez les retards sur vos chantiers. Clôturez rapidement vos démarches Mairie, Enedis, Attestation Consuel, EDF OA ou batterie virtuelle, en BT ou en HTA.",
        button: "Démarrer maintenant",
        "request-a-demo": "Demander une démo",
        "expert-at-service": "Des experts à votre écoute",
        "expert-at-service-desc":
          "Notre équipe est à votre écoute et vous accompagne dans vos démarches.",
        "for-all-your-project-type": "Pour tous vos types de projet.",
        stp: "Gagner de temps et des autorisations",
        "filling-information":
          "Renseigné les informations est laissé nous faire",
        qas: "La qualité et la rapidité",
        "qas-desc":
          "Depuis 2020, notre bureau d’études a construit un savoir-faire unique. Notre expertise sur des milliers de dossiers de toute typologie nous permet de surmonter toutes les problématiques. Nos chargés de projets sont organisés en équipes et formés pour répondre à toutes les obligations de l’administration française. Notre bureau d’étude est dirigé par des ingénieurs électriques et du BTP - qui travaillent côte à côte avec nos développeurs pour concevoir les automatisations innovantes qui ont fait notre renommée.",
        tools: "Nos outils a votre disposition",
        "tools-desc":
          "Profitez de tout les ouitls et service que vous propose notre solution pour votre administration du début à la fin",
        "next-level": "Envie de passer au niveau supérieur ?",
        "save-time": "Gagnez du temps",
        ryp: "Réduire votre paperasse",
        "quality-service": "La qualité de nos service",
        "service-needs": "Service adapté à vos besoin",
        sws: "Ils sont satisfaits de notre service",
        "urban-planning":
          "Les clés pour comprendre l’urbanisme dans votre ville",
        "urban-planning-desc":
          "Avec projetsolaire, soyez informé en quelques secondes des réglementations de  votre ville, sans besoin de recherches supplémentaires.",
        "learn-more-service": "En savoir plus sur nos services",
        "lms-desc":
          " Avec notre large gamme d’outils , vous trouverez votre bonheur grâce à notre solution de gestion de chantier de A à Z.",
        "need-clarification": "Besoin d’éclaircissements ?",
        tabs: {
          "on-the-roof": "Toiture",
          "on-the-ground": "Au sol",
          "on-a-carport": "Carport",
          "on-a-pergola": "Sur pergola",
          "on-a-roof-terrace": "Toit-terrasse",
          "solar-tile": "Tuile solaire",
          "follow-up": "Suivie",
          "invite-your-customers": "Invitez vos clients",
          "request-for-completeness": "Demande de complétude",
          reminder: "Relance",
          "problem-follow-up": "Suivie de problématique",
          "residential-tab-title": "Pour chantiers résidentiels",
          "business-tab-title": "Pour chantiers tertiaires",
        },
        steps: {
          step1:
            "Complétez les informations via mobile lors de la visite technique.",
          step2:
            "Nous envoyons votre dossier directement à la mairie en moins de 48 heures.",
          step3:
            "Nous gérons l’instruction du dossier et relançons les mairies.",
          step4:
            "Vous obtenez votre accord mairie autorisation d’urbanisme puis conformité.",
        },
        contact: "Contactez",
        "appointment-desc":
          "Prenez rendez-vous avec nous pour voir ensemble comment nous pouvons simplifier votre organisation et aider dans votre croissance.",
        "get-in-touch": "Prendre contact",
        "permission-title":
          "Gagner des heures sur chaque dossier administratif",
        "permission-desc":
          "Accélérez vos démarches pour réduire les délais de vos chantiers. Plusieurs centaines d’installateurs nous font déjà confiance.",
        "permission-title-2":
          "Éliminer des semaines de délais sur chaque dossier administratif",
        "permission-desc-2":
          "Accélérez vos démarches pour gagner des heures de vos chantiers. Plusieurs douzaines de développeurs nous font déjà confiance.",
        "management-title": "Gestion collaborative, rapide et intuitive",
        "management-desc":
          "Dotez chaque membre de votre équipe d'un puissant logiciel pour la réalisation et le suivi de vos chantiers.",
        "manage-service-title": "Gérez facilement vos chantiers",
        "manage-service-desc":
          "Depuis 2020, notre bureau d'études à construit une expertise profonde et un savoir-faire reconnu. Accélérez vos démarches avec nos automatisations et votre plateforme tout-en-un de gestion de chantiers.",
        consular: {
          residential: {
            first: "SC 144 (A ou B ou C)",
            second: "Schéma unifilaire électrique",
            third: "Stockage batteries (Violet)",
            title: "Demandes de visa de l’Attestation Consuel",
            description:
              "La réalisation de toutes les démarches auprès du Consuel pour votre système photovoltaïque. Obtention des attestations de conformité - bleu ou violette.",
          },
          business: {
            first: "SC 144 (A ou B ou C)",
            second: "Schéma unifilaire électrique",
            third: "Attestation S21",
            title: "Bureau de contrôle et visa Consuel",
            description:
              "La réalisation de toutes les démarches auprès du Consuel pour votre système photovoltaïque. Obtention des attestations de conformité - bleu ou violette.",
          },
        },
        urbanPlanning: {
          residential: {
            first: "Déclarations préalables",
            second: "Permis de construire",
            third: "Recours gracieux et DAACT",
            title: "Demandes d’autorisations d’urbanisme",
            description:
              "La réalisation de la démarche d'urbanisme pour votre système photovoltaïque auprès des institutions locales, et aussi ABF, CAUE, parcs régionaux, etc.",
          },
          business: {
            first: "Déclarations préalables ‘Petit sol’",
            second: "Permis de construire et architecte",
            third: "Constat huissier et DAACT",
            title: "Demandes d’autorisations d’urbanisme",
            description:
              "La réalisation de la démarche d'urbanisme pour votre système photovoltaïque auprès des institutions locales, et aussi ABF, CAUE, parcs régionaux, etc.",
          },
        },
        connections: {
          residential: {
            first: "Enedis ou Régie locale",
            second: "EDF Obligation Achat ou CACSI ou ARPE",
            third: "Batterie virtuelle",
            title: "Demandes de raccordement avec EDF OA",
            description:
              "La réalisation des démarches de raccordement de votre système photovoltaïque auprès du gestionnaire du réseau de distribution et d'un co-contractant, jusqu'à 500 kVA.",
          },
          business: {
            first: "Enedis ou Régie locale",
            second: "EDF Obligation Achat ou ARPE",
            third: "Autoconsommation collective",
            title: "Demandes de raccordement en BT ou HTA",
            description:
              "La réalisation des démarches de raccordement de votre système photovoltaïque auprès du gestionnaire du réseau de distribution et d'un co-contractant, jusqu'à 500 kVA.",
          },
        },
        "service-client-360": "Service client 360°",
        "service-client-360-desc":
          "Gardez le contrôle avec notre service client multi-canal et disponible toute l’année.",
        managementTabs: {
          "visite-technique": "Visite technique",
          "envois-48-heures": "Envois 48 heures",
          "suivi-daté-en-temps-reel": "Suivi daté en temps réel",
          "demande-de-pieces": "Demande de pièces",
          relances: "Relances",
          "visite-technique-title": "Assistance mobile de VT",
          "envois-48-heures-title": "Gestion à grande échelle",
          "suivi-daté-en-temps-reel-title": "Transparence totale",
          "demande-de-pieces-title": "Organisation simplifiée",
          "relances-title": "Traitements accélérés",
          "visite-technique-desc":
            "Vos technico-commerciaux peuvent facilement télécharger les photos et infos en déplacement.",
          "envois-48-heures-desc":
            "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
          "suivi-daté-en-temps-reel-desc":
            "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
          "demande-de-pieces-desc":
            "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
          "relances-desc":
            "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        },
        "solutions-title": "Solutions à la demande et à la carte",
        "solutions-desc":
          "Une gestion automatisée et tout-en-un de toutes vos opérations photovoltaïques par un seul interlocuteur.",
        "solutions-orange": "Sans abonnement. Sans engagement.",
        breadcrumb: {
          administration: "Validation chantier",
          "autorisation-urbanisme": "Autorisation Urbanisme",
          "demande-de-raccordement": "Demande de Raccordement",
          "demande-consuel": "Visa Consuel",
        },
        "procedure-title": "Démarches administratives",
        expertAtService: {
          "know-how-since": "Savoir-faire depuis 2020",
          "know-how-since-desc":
            "Une expertise unique et un accompagnement à grande échelle.",
          "100-online": "100% en ligne",
          "100-online-desc":
            "Une expérience totalement en ligne et mobile pour une efficacité maximale.",
          "speed-quality": "Rapidité et qualité",
          "speed-quality-desc":
            "Grâce à un processus d’automatisations innovant et reconnus.",
        },
      },
    },
    "value-propositions": {
      "why-us": "Une gestion collaborative",
      title: "Passez au niveau supérieur",
      "paragraph-1":
        "Dotez chaque membre de votre équipe d'un puissant logiciel pour la réalisation et le suivi de vos chantiers. L'outil informatique réduit vos délais, et permet à tous d’y voir plus clair.",
      "paragraph-2":
        "Vos commerciaux peuvent facilement télécharger les photos et documents sur votre compte.",
      "paragraph-3":
        "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
      "key-values": {
        value1: {
          title: "Envoi des dossiers",
          description: "dès l'obtention des informations.",
        },
        value2: {
          title: "Dépôt avec preuves  ",
          description: "et mises à jour en temps réel.",
        },
        value3: {
          title: "Traitement des pièces complémentaires",
          description: "inclut dans chaque prestation.",
        },
        value4: {
          title: "Relances des autorités",
          description: "proactivement par email et par téléphone.",
        },
        value5: {
          title: "Réception et partage des documents",
          description: "en format PDF directement sur compte.",
        },
        value6: {
          title: "Suivi daté du dossier",
          description: "visible en temps réel.",
        },
        value7: {
          title: "Interlocution des autorités",
          description: "et autres acteurs du dossier.",
        },
        value8: {
          title: "Obtention des autorisations",
          description: "du début à la fin.",
        },
      },
    },
    services: {
      "dematerialize-paperwork": {
        heading: "Dématérialisez vos papiers",
        title: "Demandes d'autorisations d'urbanisme",
        description:
          "La réalisation de la démarche d’urbanisme pour votre système photovoltaïque auprès des institutions locales, et aussi ABF, CAUE, parcs régionaux, etc.",
        feat1: "Déclarations préalables",
        feat2: "Permis de construire (max. 800m²)",
        feat3: "Recours gracieux",
      },
      "reduce-delays": {
        heading: "Réduisez les délais",
        title: "Demandes de raccordement",
        description:
          "La réalisation des démarches de raccordement de votre système photovoltaïque auprès du gestionnaire du réseau de distribution et d’un co-contractant, jusqu'à 500 kVA.",
        feat1: "Enedis ou Régie locale",
        feat2: "EDF Obligation Achat ou contrat S21",
        feat3: "Batterie virtuelle (Urban Solar, MyLight, JPME)",
      },
      "outsource-authorizations": {
        heading: "Externalisez vos autorisations",
        title: "Demandes de visa Consuel",
        description:
          "La réalisation de toutes les démarches auprès du Consuel pour votre système photovoltaïque. Obtention des attestations de conformité - bleu ou violette.",
        feat1: "SC 144 (A ou B ou C)",
        feat2: "Schéma unifilaire électrique",
        feat3: "AC visé en BT ou HTA",
      },
    },
    products: {
      title: "Nos solutions à la carte",
      paragraph:
        "Une gestion dématérialisée et à la demande de toutes vos démarches administratives photovoltaïques par un seul interlocuteur.",
      "requests-for-urban-planning-authorizations": {
        title: "Demandes d'autorisations d’urbanisme",
        subtitle:
          "La réalisation de la démarche d’urbanisme pour votre système photovoltaïque auprès de l’institution locale compétente.",
        "paragraph-1":
          "Dématérialisation des dossiers de déclaration préalable (ou permis de construire) grâce à l’API du Géoportail et l’utilisation systématique de guichet unique.",
        "paragraph-2":
          "Obtention de non-opposition, en PLU ou RNU. Envoi puis suivi des dossiers, avec preuves de dépôt et avis de réception des lettres recommandées. Relances matinales des mairies par téléphone.",
        "paragraph-3":
          "Interlocution avec Bâtiments de France (ABF), parcs régionaux, et autres autorités jusqu’à l’attestation de non-opposition à la conformité.",
      },
      "request-for-enedis": {
        title: "Demandes de raccordement",
        subtitle:
          "La réalisation de toutes les démarches de raccordement de votre système photovoltaïque auprès du réseau électrique Enedis et d'un cocontractant.",
        "paragraph-1":
          "Obtention de PDR ou PTF, CRAE ou CAE pour production d'électricité solaire (ou augmentation de puissance). Obtention aussi de la simulation du prix du devis Enedis selon le barème de facturation.",
        "paragraph-2":
          "Envoi et relance  Relance et suivi de l’avancement des dossiers par messagerie Enedis.",
        "paragraph-3":
          "Inclus aussi l’obtention EDF OA pour votre client, ou bien la démarche avec un co-contractant auprès de tous les fournisseurs de batterie virtuelle (Urban Solar Energy, MyLight150, JPME).",
      },
      "requests-for-consuel": {
        title: "Demandes de visa Consuel",
        subtitle:
          "La réalisation de toutes les démarches auprès du Consuel pour votre système photovoltaïque. Obtention des attestations de conformité.",
        "paragraph-1":
          "La réalisation de la fiche de collecte, du SC 144 (A/B) et du schéma électrique unifilaire auprès du Consuel pour votre système photovoltaïque. Gestion et suivi du dossier jusqu’à l’obtention pour mise en service de l’Attestation de Conformité « Bleu » (n°15523*01). Création et Test de l’attestation. Prévention de l’inspection du Consuel et planification de la visite.",
        "paragraph-2":
          "Avertissement : service exclut l’achat des d’Attestations de Conformité (AC). Le service numérique n’est à ce jour pas connecté au compte Consuelpro.com",
      },
    },
    "new-pricing": {
      pricing: "Grille tarifaire",
      title: "Une tarification simple à l'utilisation",
      paragraph:
        "Choisissez un plan abordable et flexible qui répond précisement à votre besoin - toujours disponible à la demande pour réduire vos délais.",
      "producer-size": "Type de producteur",
      option: {
        "small-producer": "Dossiers pour particuliers et <36 kWc",
        "large-producer": "Dossiers grands producteurs",
      },
      "buy-plan": "Démarrer dossier",

      "price-card": {
        "requests-for-urban": {
          title: "Demandes d'autorisations d'urbanisme",
          price: {
            small: "149 €",
            "<250": "299 €",
            "<500": "299 €",
            "500+": "299 €",
          },
          tax: "HT",
          features: {
            feat1: "Plans & documents graphiques",
            feat2: "PC (pour photovoltaïque)",
            feat3: "Service avec architecte",
            feat4: "DAACT",
            feat5: "Recours grâcieux",
            feat6: "Chargé de dossier dédié",
          },
          "description-small":
            "Notre avantage : Défense de vos déclarations préalables auprès des services d'instruction, ABF, CAUE, parcs régionaux, etc.",
          "description-large":
            "Notre avantage : Défense de vos permis de construire auprès des services d'instruction, ABF, CAUE, parcs régionaux, etc.",
        },
        "requests-for-enedis": {
          title: "Demandes de raccordement",
          price: {
            small: "99 €",
            "<250": "599 €",
            "<500": "1499 €",
            "500+": "1999 €",
          },
          tax: "HT",
          features: {
            feat1: "Enedis ou Régie locale",
            feat2: "EDF OA",
            feat3: "Batterie virtuelle",
            feat4: "Obtention Attestation ENR S21",
            feat5: "Décalage T-0 pour S21",
            feat6: "Chargé de dossier dédié",
            feat7: "Signalétique transformateur",
            feat8: "Obtention ARPE",
            feat9: "Harmoniques de(s) onduleur(s)",
            feat10: "Demande de nouveau PRM",
          },
          "description-small":
            "Notre avantage : Suivi proactif et rapide de la messagerie d’Enedis afin de réagir proactivement pour les commandes de mise en service.",
          "description-large":
            "Notre avantage : Relances email et téléphone jusqu'à 3 fois par semaine pour CRD puis PTF puis CARD-i auprès de l'agent du GDR.",
        },
        "requests-for-consuel": {
          title: "Demandes de Visa Consuel (bleu et violette)",
          price: {
            small: "66 €",
            "<250": "399 €",
            "<500": "399 €",
            "500+": "399 €",
          },
          tax: "HT",
          features: {
            feat1: "SC 144 A/B/C",
            feat2: "Schéma unifilaire électrique",
            feat3: "Rapport de contrôle",
            feat4: "Intégration avec Enedis",
            feat5: "Stockage avec batteries",
            feat6: "Chargé de dossier dédié",
          },
          "description-small":
            "Notre avantage : Réduction des fréquences des inspections en assurant le respect de la norme NF C 15-100 du visa Consuel.",
          "description-large":
            "Notre avantage : Prise en charge de l'intérlocution avec les organismes agréés pour inspections puis obtentions DRE rapides.",
        },
        package: {
          title: "Dossier complet jusqu'à la valorisation du surplus",
          price: {
            small: "249 €",
            "<250": "999 €",
            "<500": "1899 €",
            "500+": "2499 €",
          },
          tax: "HT",
          features: {
            feat1: "Autorisation d'Urbanisme",
            feat2: "Attestation ENR S21",
            feat3: "Bureau de contrôle",
            feat4: "Visa Consuel",
            feat5: "Mise en service",
            feat6: "EDF OA ou batterie virtuelle",
            feat7: "Signalétique transformateur",
            feat8: "Obtention ARPE",
          },
          "description-small":
            "Le plus : Envoi des démarches administratives dès la conclusion de la précedente, afin de réduire de plusieurs semaines les délais.",
          "description-large":
            "Le plus : Envoi des démarches administratives dès la conclusion de la précedente, afin de réduire de plusieurs semaines les délais.",
        },
      },
    },
    cta: {
      title: "Démarrer dès la signature de votre devis",
      paragraph:
        "Notre gamme complète de services numériques avec base de données de matériel intégrée automatise votre gestion administrative, de l'envoi au suivi de vos dossiers.",
      button: "Faire une première demande",
      "learn-more": "Documentation",
    },
  },
  "digital-sales-tools": {
    hero: {
      interested: "Envie d'en savoir plus ?",
      "request-a-demo": "Demander une démo",
      title: "Une étude solaire digne de confiance",
      paragraph:
        "Les ventes photovoltaïques typiques sont encombrantes, lentes et croupissantes. Nous permettons d'apporter une visibilité sur 25 ans aux propriétaires à partir du kWh. Rationalisez les processus, réduisez vos coûts, et impulsez votre croissance grâce à des études en ligne et sur-mesure.",
      button: "Démarrer maintenant",
      "learn-more": "Demander un démo",
      animation: {
        intro: {
          welcome: "Bienvenue",
        },
        production: {
          title: "Votre production annuel",
          paragraph:
            "Votre potentielle production d'électricité solaire est déterminée en fonction du nombre et de la puissance (en kWc) de vos panneaux solaires,ainsi que de leurs rendements énergétiques (en kWh/kWc).",
        },
        consumption: {
          title: "Votre consommation annuel",
          paragraph:
            "Votre consommation annuelle d'électricité est déterminée en fonction de la quantité d'électricité que vous utilisez, mesurée en kilowattheures (kWh).Cela dépend de vos habitudes de consommation.",
        },
        system: {
          title: "Mon système solaire",
          paragraph:
            "Nous vous réalisons votre projet solaire. Voici votre bien actuel sans panneaux photovoltaïques.",
          value: {
            "technical-specs": {
              title: "Cahier de charges",
              value: "16 kWc",
            },
            type: {
              title: "Type",
              value: "Classique",
            },
            "cellular-photovoltaique": {
              title: "Cahier de charges",
              value: "Monocristallins",
            },
            inverters: {
              title: "Onduleur",
              value: "Micro-onduleurs",
            },
            "manufacturer-warranty": {
              title: "Guarantie de fabricant",
              value: "25 ans",
            },
          },
        },
      },
    },
    configurable: {
      styling: {
        title: "En marque blanche",
        paragraph:
          "Vous souhaitez personnaliser les études de vos clients en fonction de votre marque et charte graphique ? Essayez !",
        types: {
          "theme-preset": {
            title: "Thèmes prédéfinis",
            description:
              "Vous trouverez ci-dessous quelques thèmes suggérés pour personnaliser votre présentation.",
          },
          custom: {
            title: "Sélectionnez vos couleurs",
            description:
              "Sélectionnez la palette de couleurs de tous les composants pour créer votre propre thème de couleurs.",
          },
        },
        themes: {
          presets: {
            default: "Défaut",
            blue: "Bleu",
            purple: "Violet",
            orange: "Orange",
            yellow: "Jaune",
            green: "Verte",
            rose: "Rose",
            sky: "Bleu ciel",
            teal: "Bleu canard",
            emerald: "Emerald",
            fuchsia: "Rose fuschia",
            violet: "Lavande",
            red: "Red",
            cyan: "Bleu cyan",
            slate: "Gris ardoise",
            pink: "Incarnat",
          },
        },
        custom: {
          "background-color": {
            title: "Couleur de fond",
            description:
              "Personnaliser la couleur principale de votre marque, qui s'affiche sur toutes les pages.",
            primary: "Primaire",
            secondary: "Secondaire",
            tertiary: "Tertiaire",
            sidebar: "Barre latérale",
          },
          "button-color": {
            title: "Couleur de bouton",
            description:
              "Personnaliser la couleur secondaire de votre marque, qui s'affiche sur tous les boutons.",
            primary: "Primaire",
            secondary: "Secondaire",
            link: "Couleur de link",
          },
          "text-color": {
            title: "Couleur de text",
            description:
              "Personnaliser la couleur secondaire de votre marque, qui s'affiche sur tous les text.",
            paragraph: "Paragraphe et titres",
            "chart-labels": "Étiquettes des graphiques",
            category: "Titre",
            sidebar: "Barre latérale",
          },
        },
      },
    },
    "value-proposition": {
      "everything-you-need": "Méthode technico-financière sur 25 ans",
      title: "Optez pour la précision technique",
      paragraph:
        "Afin d'apporter le maximum de transparence pour lutter contre l'éco-délinquance, nous avons développé un calcul mathématique du pourcentage d'autonomie électrique à partir de mesures horaires d'électricité – matin, midi, soir et nuit … l’été comme l’hiver – sur 25 ans.",
      "key-value": {
        a: {
          title: "Plusieurs dimensionnements par étude",
          description:
            "avec votre choix de matériel à partir de milliers de modèles. Chiffrez vos propositions pour augmenter la rentabilité et votre taux de conversion. Téléchargez l’étude en format PDF.",
        },
        b: {
          title: "Guichet intégré pour modifications",
          description:
            "et corrections gratuites, avec délais estimatifs sur 24 heures. Mettez votre étude en ligne, prête pour partage, quand vous êtes content. Accessible sur smartphone.",
        },
        c: {
          title: "Facture électrique obligatoire du propriétaire",
          description:
            "pour calculer les économies, à partir du dernier prix du kWh, plages horaires (HP & HC), abonnement, taxes locales, montant de la TVA, conditions du contrat.",
        },
      },
    },
    features: {
      a: {
        title: "Historique de consommation",
        paragraph:
          "Accédez à la courbe de charge réelle du propriétaire. Notre étude technico-financière sur 25 ans repose sur les mesures horaires (en kWh). L’historique de consommation est obtenu directement depuis le compteur Linky d'Enedis. Cette précision technique permet de calculer l'autoconsommation électrique heure par heure.",
        paragraph2: "projetsolaire :",
        paragraph3: "une entité référencée auprès d'Enedis",
        button: "Get started",
      },
      abis: {
        title: "Dimensionnement de calepinage",
        paragraph:
          "Générez une courbe horaire en kWh du productible photovoltaïque de votre calepinage. La simulation est calculée depuis l'irradiance du site, à partir des données historiques des stations météorologiques. Le gisement solaire est calculé heure par heure du lever au coucher du soleil, en prenant en compte la saisonnalité, sur 365 jours.",
      },
      abisbis: {
        title: "Précision au kWh/m²",
        paragraph:
          "Prenez en compte les orientations & inclinaisons & ombrages exacts avec la télédétection Lidar en 3D du relief au 0,10m ; permettant des modélisations à distance des surfaces. Optez pour une évaluation de l'ensoleillement au kWh/m² avec calcul précis du productible photovoltaïque. Différenciez-vous des simulations concurrentes.",
      },
      b: {
        title: "Solutions de stockage",
        paragraph:
          "Explorez les solutions de stockage du système solaire - batterie virtuelle, batteries physiques, ou stockage thermique. Maximisez le pourcentage d'autonomie électrique et démontrer mathématiquement comment le stockage permet de réduire les imports d'électricité auprès du réseau électrique, et d'augmenter ainsi la rentabilité.",
        button: "Get started",
      },
      c: {
        title: "Prévisionnels financiers",
        paragraph:
          "Analysez l'autofinancement et faites valider le dossier de financement pour débloquer plus de revenus, sans jamais quitter la présentation en ligne. L'étude de rentabilité permet de comparer le retour sur investissement et la période d'amortissement du système solaire au comptant, par prêt bancaire, ou bien en location toiture.",
        button: "Get started",
      },
      d: {
        title: "Gestion de la relation client",
        paragraph:
          "Éliminez les approximations des ventes grâce à des flux de travail rationalisés et avec une interface intuitive de gestion des études et des propositions. Gagnez l'adhésion avec notre logiciel tout-en-un permettant à votre équipe de réussir à chaque étape du parcours client avec commentaires, fiches, et attributions des responsables.",
        button: "Get started",
      },
      e: {
        title: "Entièrement personnalisable",
        paragraph:
          "Envoyez à votre client une proposition de vente personnalisée et interactive pour le garder enthousiaste et engagé, même après avoir quitté le rendez-vous. Des modèles de diapositives pré-définit vous permettent d'ajouter facilement des pages dynamiques et des images personnalisées pour vous démarquer de la concurrence.",
        button: "Get started",
      },
      f: {
        title: "Mini-site sur internet",
        paragraph:
          "Augmentez votre chiffre d'affaires avec des présentations accessibles sur un mini-site internet via un lien unique, interactives sur n'importe quel appareil. Rationalisez le processus de vente grâce à la génération automatisée de contrats, tableaux et graphiques de rentabilité, et à la signature électronique intégrée.",
        button: "Get started",
      },
    },
    pricing: {
      title: "Tarification adaptés aux besoins",
      paragraph:
        "Le service numérique des études en ligne du photovoltaïque sont encore en bêta.",
      "on-card": {
        title: "Étude du photovoltaïque et du stockage",
        paragraph:
          "Contactez-nous pour obtenir des informations sur les prix et abonnements et autres renseignements.",
        "what-included": "Ce qui est aussi inclus",
        features: {
          feat1: "Attributions aux chargés de clientèle",
          feat2: "Fonctionnement sans Lidar ni Linky",
          feat3: "Demandes de modifications aux études",
          feat4: "Plusieures propositions par étude",
        },
        "pay-as-you-go": "À la demande",
        "price-big": "30 €",
        "price-small": "À partir de",
        "join-waiting-list": "Demander une démo",
        button: "Contacter service commercial",
        "free-sample": "Obtenez un échantillon gratuit",
      },
    },
    "help-center": {
      title: "Différenciez-vous de la concurrence",
      paragraph:
        "Soyez parmi les premiers à exploiter nos études technico-financières de rendement.",
      button: "Démarrer maintenant",
      "request-a-demo": "Documentation",
    },
  },

  discover: {
    systeme: {
      datasheet: {
        title: "Fiche technique",
        paragraph: "Vous trouverez ci-dessous les détails techniques du projet",
        systemepower: "Puissance du système",
        numberpanels: "Nombre de panneau",
        panelstype: "Type de panneaux",
        roofheight: "Hauteur du toit",
        roofstructure: "Structure du toit",
        roofmaterials: "Matériaux du toit",
        roofaccessibility: "Accessibilité du toit",
        panelpreference: "Préférence panneau",
        quotenumber: "Nombre de devis reçu",
        Typenetworkconnection: "Type de branchement",
        powernetworkkva: "Puissance de la Souscription du réseau en kVA",
      },
    },
  },

  "case-studies": {
    "logo-cloud": {
      text: "Plus de 600 installateurs utilisent nos outils pour améliorer leur activité.",
      link: "Lisez nos témoignages clients",
    },
    home: {
      header: {
        title: "Ils utilisent projetsolaire.com tous les jours",
        overview: "Témoignages de nos clients",
        all: "Tous les témoignages et cas d'usage de nos clients",
      },
      overview: {
        hero: {
          title:
            "Témoignages de notre solution informatique : simple et puissante",
          paragraph:
            "L'objectif de notre plateforme est de permettre aux installateurs photovoltaïques à forte croissance d'exploiter les technologies numériques de pointe de manière simple et collaborative. Notre solution informatique est co-développée avec nos clients pour qu'ils puissent gagner du temps pour faire plus. Nous opérons sur l'ensemble du territoire national et propulsons des milliers de projets solaires chaque année pour des entreprises de toutes tailles, des artisans de proximité aux leaders du solaire.",
        },

        stats: {},

        testimonials: {
          heading: "Témoignages",
          title:
            "Nous travaillons avec des centaines d'installateurs incroyables",
        },

        featured: {
          title:
            "L’outil informatique pour la filière photovoltaïque de France",
        },

        cta: {
          title: "Envie d’essayer ?",
          paragraph:
            "Créez un compte et commencer à piloter vos chantiers, sans frais d’inscription ni besoin de renseigner de coordonnés bancaires. Vous pouvez explorer les services numériques pour concevoir un outil informatique sur-mesure pour votre activité.",
          "button-1": "Commencer",
          "button-2": "Demander une démo",
          "column-1": {
            title: " Contacter notre équipe  ",
            paragraph:
              "Ayez toujours une idée claire de ce que vous payez. Une tarification a l’utilisation sans grille tarifaire au cas par cas",
            button: "Tarification",
          },
          "column-2": {
            title: "Démarrez votre intégration ",
            paragraph: "Lancez-vous sur projetsolaire en seulement 10 minutes",
            button: "Ouverture du compte",
          },
        },
      },
      all: {
        title:
          "Témoignages de notre solution informatique : simple et puissante",
        description:
          "Découvrez quelques-uns de nos centaines de clients professionnels qui bénéficient de projetsolaire.com au quotidien. Pourquoi pas vous ?",
      },
    },
    entry: {
      breadcrumb: {
        installer: "Professionnels",
        "case-studies": "Cas d'usage",
      },
      "case-study": "Cas d'usage",
      meet: "Rencontrez",
      "learn-more":
        "En savoir plus sur comment nous pouvons optimiser vos installations photovoltaïques",
      "read-more": "Voir tous les cas d'usages",
    },
    country: "Pays",
    "commercial-objective-sales": {
      sales: "Solutions de ventes",
      operations: "Solutions opérationnelles",
    },
    product: {
      label: "Produits utilisés",
      products: {
        sales_solutions: "Génération leads",
        design: "Dimensionnement",
        platform: "Gestion équipe gratuite",
        permitting: "Urbanisme",
        integrated_financing: "Financement",
        grid: "Raccordement et Consuel",
        hardware: "Gestion du matériel",
      },
    },
  },
  directory: {
    department: {
      find: "Trouvez",
      photovolatic: "l’installateur photovoltaïque",
      "near-you": "pour votre projet solaire proche de chez vous",
      "desc-1":
        "Pour vous, nous avons sélectionner les meilleurs installateurs de panneau solaires pour que votre projet déroule sans mauvaise surprise.",
      "desc-2":
        "Veuillez sélectionnez un département en cliquant directement sur la carte ou bien en saisissant si dessous le nom du département ou le code postal.",
      placeholder: "Saississez votre département ou code postal",
      installers: "Installateurs",
      duration: "Durée estimée",
      "service-offer": "Service propés",
      certification: "Certification",
      "how-to-achieve": {
        title: "Comment accéder à l’autonomie solaire?",
        description:
          "Avec ces 7 étapes, accédez facilement à l’autonomie solaire, réduisez vos factures et profitez d’une énergie propre et durable.",
        step1: {
          title: "Choisir mon système solaire",
          description:
            "Bénéficiez d’une étude de votre pourcentage d’autonomie électrique, et donc de vos économies.",
        },
        step2: {
          title: "Choisir mon devis sur-mesure",
          description:
            "Recevez plusieurs propositions complètes et détaillées d’installateurs photovoltaîques RGE.",
        },
        step3: {
          title: "Valider faisabilité du chantier",
          description:
            "Rencontrez le technicien chez vous pour la faisabilité technique du cahier des charges.",
        },
        step4: {
          title: "Investir dans le solaire",
          description:
            "Faites encadrer votre investissement en contrôlant le devis et les asssurances du maître d’oeuvre",
        },
        step5: {
          title: "Réalisation des démarches",
          description:
            "Obtenez l’autorisation de l’urbanisme auprès de la mairie en respectant les normes en vigeur.",
        },
        step6: {
          title: "Pose & mis en service",
          description:
            "Valorisez la production de votre installation photovoltaîque raccordée au réseau électrique.",
        },
        step7: {
          title: "Service après installation ",
          description:
            "projetsolaire vous accompagne même après que votre installation soi poser pour la maintenance de vos panneaux.",
        },
        stage: "Etape",
      },
      hero: {
        department: {
          habitants: {
            title: "389 203 habitants",
            description:
              "La departement du {department} compte 389 203 habitants.",
          },
          "protected-areas": {
            title: "Zone protégées",
            description:
              "La departement du {department} compte 18 monuments protégés.",
          },
          rate: {
            title: "83%",
            description:
              "C’est le taux d’ensoleillement du département du {department}. ",
          },
        },
        "find-installers": "Trouvez un installateur en",
        "featured-installers-title":
          "Installateurs photovoltaïques près de chez vous",
        "installer-verify": "Installateur verifié",
        certification: "Certification",
        "get-quote": "Obtenir un devis",
        link: "C’est mon entreprise",
      },
    },
    "choose-solar-energy": {
      title: "Pourquoi choisir l'énergie solaire avec projetsolaire ?",
      button: "Commencez votre parcours",
      "start-button": "Lancez mon projet solaire",
      "energy-expert-title": "Experts en rénovation énergie",
      "energy-expert-description":
        "Une équipe formée pour vous accompagner tout au long de votre projet",
      "estimate-project-title": "Une estimation sur-measure",
      "estimate-project-description":
        "Estimez votre projet en remplissaant notre formulaire et béneficiez des meilleurs tarifs",
      "free-title": "C’est complètement gratuit",
      "free-description":
        "Projet solaire vous accompagne gratuitement pour construire votre projet avec les meilleurs artisans",
    },
    "learn-more": "En savoir plus",
    "made-by": "Réaliser par",
    "read-more": "Lire son histoire",
    "project-of-week": "Projet de la semaine",
    "pow-desc": "Consulter les projets lancer avec projetsolaire",
    hero: {
      title: "Des experts prêts à vous accompagner.",
      heading: "Votre installateur solaire, près de chez vous.",
      description:
        "Lancez votre projet solaire avec un installateur à proximité, pour un service rapide, fiable et adapté à vos besoins.",
      installers: "Installateurs",
      "installation-in": "Installation en",
      satisfaction: "Satisfaction",
      days: "jours",
    },
    button: {
      "start-button": "Lancez mon projet solaire",
      "contact-us": "Contactez-nous",
    },
    "go-solar": {
      title: "Passez au solaire dès aujourd’hui !",
      description:
        "Trouvez votre installateur local en quelques clics et commencez à économiser sur vos factures tout en protégeant la planète. C’est simple, rapide et 100 % gratuit !",
    },
  },
  "use-cases": {
    heading: {
      "find-new-client": "Trouver nouveaux clients",
      "solar-sizing": "Dimensionnement solaire",
      "sales-and-marketing": "Ventes et Commercialisation",
      "quotes-and-billing": "Devis et facturation",
      "stocks-and-equipment": "Stocks et Matériel",
      "administrative-procedures": "Démarches administratives",
      "file-tracking": "Suivi des dossiers",
      "purchase-contracts-and-economic-models":
        "Contrats d’achat et modèles économiques",
      financing: "Financement",
      "work-and-construction": "Travaux et construction",
      "web-and-mobile-software-for-project-management":
        "Logiciel web et mobile de gestion de chantiers",
      "post-installation-services": "Services après installation",
      "new-prospects-and-marketing": "Nouveaux prospects et Marketing",
      "customer-service": "Service client",
      premium: "Premium",
    },
    action: {
      "price-according-on-your-€-wc": "Tarif selon votre €/Wc",
      "without-subscription": "Sans abonnement",
      "no-subscription": "Aucun abonnement",
      free: "Gratuit",
      "usage-based-pricing": "Tarif à l’utilisation",
    },
    testimonials: {
      header: "Témoignages de clients",
      title: "Qui de mieux que nos clients pour parler de projetsolaire.com",
      type: {
        sales: "Solutions de ventes",
        operations: "Solutions opérationnelles",
      },
    },
    "request-demo": "Demander une démo",
    "start-now": "Démarrer maintenant",
    cta: {
      title: "Dépasser la concurrence",
      description:
        "Découvrez pourquoi les équipes intelligentes utilisent déjà projetsolaire.com",
    },
    "project-contact": {
      title: "Tous vos chantiers. Un seul interlocuteur spécialisé.",
      description:
        "Depuis 2020, notre bureau d’études à construit une expertise profonde et un savoir-faire reconnu. Accélérez vos chantiers et dossiers avec nos automatisations et votre plateforme tout-en-un de gestion de chantiers.",
      button: "Envoyer",
      services: {
        service1: {
          title: "Toutes les puissances en KW et MW",
          description:
            "Notre équipe de spécialistes vous accompagne pour chantiers particuliers, tertiaires, BT et HTA.",
        },
        service2: {
          title: "Tous les types de chantiers PV",
          description:
            "Projets solaires en toiture, en neuf, ombrière, ‘petit sol’ ? Nous pouvons vous aider.",
        },
        service3: {
          title: "Partout en France",
          description:
            "En DROM-COM ? Nous sommes présents en Métropole et en Outre-Mer.",
        },
      },
    },
    SMALL: {
      hero: {
        "icon-label": "Études de cas",
        "discover-solutions": "Découvrir solutions",
        "book-demo": "Demander une démo",
        "name-orange": "Artisan solaire",
        "name-black": "souhaitant gagner du temps",
        description:
          "Vous êtes un installateur photovoltaïque de proximité ? Découvrez comment les professionnels utilisent projetsolaire au quotidien pour gagner de l’argent.",
      },
      works: {
        heading: "Comment ça marche",
        title:
          "Bureau d’études numérique au service de l’artisanat photovoltaïque.",
        steps: {
          step1: {
            title: "Ouverture du compte",
            heading:
              "Sans engagement. Inscription rapide et gratuite en ligne. Puis, complétez le compte avec décennale, RGE et autres documents.",
          },
          step2: {
            title: "Ajouter le premier chantier",
            heading:
              "Renseignez un client et un chantier en quelques clics. Gérez les dates et déplacements, puis la liste du matériel et les devis sur l’outil.",
          },
          step3: {
            title: "Ajouter prestation à la carte",
            heading:
              "Besoin de faire le calepinage ? Une étude complète avec devis ? Ou bien l’accord mairie ? Utilisez uniquement ce dont vous avez besoin.",
          },
        },
      },
      "product-listing": {
        title: "Solutions tout-en-un et à la carte",
        description:
          "Découvrez la solution de référence de la filière photovoltaïque, reconnue comme N°1 par des centaines de clients.",
        button: "En savoir plus",
        connection: "Mise en relation",
        "connection-desc":
          "Découvrez des clients potentiels directement depuis votre compte, sans payer de commissions d’apporteurs d’affaires.",
        "project-management-assistance-title":
          "Assistance de maîtrise d’ouvrage",
        "project-management-assistance-desc":
          "Le maître d’œuvre fixe le prix et le matériel. Bénéficiez des outils visite technique et signature électronique pour accélérer vos ventes",
        "3d-sizing-tool-title": "Outil de Dimensionnement en 3D",
        "3d-sizing-tool-desc":
          "Nous avons intégré Aurora Solar pour vous offrir la solution la plus puissante et techniquement précise de productible photovoltaïque.",
        "shading-masks-compliant-with-rge-audit-title":
          "Masques d’ombrages conforme à l’audit RGE",
        "shading-masks-compliant-with-rge-audit-desc":
          "Optez pour la précision du LIDAR au 0,10m en 3D pour réaliser des évaluations de l’ensoleillement au kWh/m² partout en France.",
        "enedis-api-title": "API Enedis et Données du compteur Linky",
        "enedis-api-desc":
          "Analysez l'autoconsommation électrique de vos clients au travers de leurs historique horaire de consommation en kWh.",
        "self-consumption-title":
          "Études en autoconsommation ou vente en totalité",
        "self-consumption-desc":
          "Proposez des études extraordinaires et complètes, avec nombre illimité de propositions technico-financières par études.",
        "virtual-battery-title": "Études comparative Batterie Virtuelle",
        "virtual-battery-desc":
          "Comparez la rentabilité du contrat EDF OA avec les fournisseurs de batterie virtuelle MyLight Systems, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Études de batterie physique",
        "physical-battery-studies-desc":
          "Ajoutez un modèle de batterie physique et fiche technique pour analyse horaire de l’autoconsommation et de la rentabilité du stockage.",
        "edf-oa-purchase-tariff-title":
          "Veuille du tarif d’achat EDF OA en métropole et ZNI",
        "edf-oa-purchase-tariff-desc":
          "Les primes d’État et tarifs d’achat de nos études sont mise à jour tous les trimestres avec les nouveaux arrêté tarifaires de la CRE.",
        "purchase-tariff-comparison-title":
          "Comparatif destarifs d’achat par T-0",
        "purchase-tariff-comparison-desc":
          "Comparez la rentabilité des centrales photovoltaïques par rapport aux aides de l’État sur les différents trimestres pour accélérer vos ventes.",
        "credit-financing-simulator-title":
          "Simulateur de crédit et financement",
        "credit-financing-simulator-desc":
          "Analysez l’investissement au comptant, au travers d’un crédit, ou bien de location de toiture - directement intégré dans l’étude.",
        "white-label-support-formats-title":
          "Tous les formats de support en marque blanche",
        "white-label-support-formats-desc":
          "Études en mini-site interactif internet ou PDF ou feuille de calcul ou mobile.",
        "quotes-with-integrated-hardware-title": "Devis avec matériel intégré",
        "quotes-with-integrated-hardware-desc":
          "Préparez vos devis à partir d'une base de données avec milliers de modules, onduleurs, coffrets, batterie.",
        "accounting-numbering-of-quotes-title":
          "Numérotation comptable des devis",
        "accounting-numbering-of-quotes-desc":
          "Personnalisez aussi vos couleurs, vos CGV, fiches techniques, attestation TVA, et bien plus encore de vos devis.",
        "electronic-signature-title": "Signatures électroniques conformes",
        "electronic-signature-desc":
          "Rédigez puis faites signer en ligne vos devis, avec vos références et mentions. Retrouvez vos devis et documents sur votre compte.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Factures comptables pour acomptes et soldes",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Définissez vos acomptes, gérer vos transactions, ajouter vos factures, et bien plus encore.",
        "secure-payments-title":
          "Paiements sécurisés par virement ou carte bancaire",
        "secure-payments-desc":
          "Percevez vos revenus via des pages de paiements simples, avec plusieurs modes de paiement, intégrées aux devis et factures.",
        "product-references-title":
          "10000+ références produits : modules, onduleurs, coffrets, batteries ...",
        "product-references-desc":
          "Choisissez le modèle de produit depuis notre base de données mise à jour en temps réel. Sauvegardez vos kits et listes de matériel pour saisie réduite des devis et démarches.",
        "construction-site-equipment-lists-title":
          "Listes de matériel des chantiers",
        "construction-site-equipment-lists-desc":
          "Planification automatique des listes de produits et équipements pour installations photovoltaïque.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Fiches techniques et Certificats de conformités et Bilan carbone",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Notre base de données contient des milliers de documents à jour pour vos démarches.",
        "professional-technical-documentation-title":
          "Documentation technique professionnelle",
        "professional-technical-documentation-desc":
          "Générez automatiquement des schémas de câblage, Attestations de bridage, et Plans d’exécution.",
        "material-ordering-title": "Commande du matériel",
        "material-ordering-desc":
          "Demandez des devis des fabricants et distributeurs pour trouver des prix compétitifs en ligne.",
        "urban-planning-authorization-requests-title":
          "Demandes d’autorisation d’urbanisme",
        "urban-planning-authorization-requests-desc":
          "La réalisation de la Déclaration Préalable ou Permis de Construire pour votre installation photovoltaïque auprès des institutions locales compétentes pour accord en mairie.",
        "gracious-appeal-title": "Recours gracieux et DAACT",
        "gracious-appeal-desc":
          "La réalisation du DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes. En cas de refus, réalisation du recours gracieux.",
        "architect-communication-title": "Interlocution avec architectes",
        "architect-communication-desc":
          "La réalisation des études de faisabilité de PLU/RNU, préparation des pièces graphiques, de l’attestation architecte, du dépôt en mairie en obligation architecte.",
        "connection-requests-title": "Demandes de raccordement",
        "connection-requests-desc":
          "L’obtention du contrat CAE et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "collective-self-consumption-connection-requests-title":
          "Demandes de raccordement Autoconsommation Collective",
        "collective-self-consumption-connection-requests-desc":
          "Notre partenaire spécialisé est intégré directement dans votre compte pour création communauté et PMO. Réalisation des demandes CAE et clés de répartition.",
        "consuel-certificate-title":
          "Demandes de visa de l’Attestation Consuel",
        "consuel-certificate-desc":
          "La réalisation du SC144-A ou SC144-B ou SC144-C, la réalisation du Schéma unifilaire électrique, puis dépôt de l’Attestation de conformité Bleu ou Violette (pour batteries).",
        "control-office-title": "Bureau de contrôle et visa Consuel",
        "control-office-desc":
          "L’interlocution technique avec organismes agréés et obtention du rapport DRE de conformité. La réalisation du SC144, Schéma unifilaire électrique, puis dépôt de l’AC Bleu ou Violette.",
        "large-scale-sending-title": "Envoi en 48 heures à grande échelle",
        "large-scale-sending-desc":
          "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
        "real-time-tracking-title": "Suivi daté en temps réel",
        "real-time-tracking-desc":
          "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
        "additional-docs-title":
          "Traitement des demandes de pièces complémentaires",
        "additional-docs-desc":
          "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
        "follow-ups-title": "Relances aux instances administratives",
        "follow-ups-desc":
          "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        "edf-obligation-title": "EDF Obligation Achat",
        "edf-obligation-desc":
          "La réalisation de la démarche auprès d’EDF OA, Attestation sur l’honneur automatique ou bien l’Attestation S21 ‘ENR’ avec Bilan Carbone (au delà de 100 kWc).",
        "virtual-battery-procedure-title": "Démarche Batterie virtuelle",
        "virtual-battery-procedure-desc":
          "La réalisation de la démarche auprès d’un des trois fournisseurs de batterie virtuelle - MyLight Systems, Urban Solar Energy, JPME - pour stockage virtuel.",
        "financing-report-title": "Dossier de rentabilité de financement",
        "financing-report-desc":
          "Analysez le financement de l’investissement photovoltaïque par rapport au rendement énergétique, à partir d’un calcul horaire en kWh.",
        "payment-savings-title": "Calcul de mensualité et effort d’épargne",
        "payment-savings-desc":
          "Comparez le financement de l'investissement photovoltaïque, que ce soit en espèces ou par un prêt bancaire, en intégrant votre OPEX et EBITDA.",
        "solar-subscription-title": "Abonnement solaire",
        "solar-subscription-desc":
          "Notre partenaire spécialisé dans l’abonnement est intégré directement dans votre compte. Faites les demandes de financement par abonnement solaire dès l’étude.",
        "mobile-assistance-title": "Assistance mobile de visite technique",
        "mobile-assistance-desc":
          "Vos technico-commerciaux peuvent facilement renseigner les fiches clients et télécharger les photos et infos en déplacement.",

        "hardware-planning-title": "Planification du matériel",
        "hardware-planning-desc":
          "Listes automatiques d'inventaire des équipements des chantiers disponibles par chantier et par flux, pour contrôle du matériel et des commandes.",
        "integrated-calendar-title": "Agenda intégré",
        "integrated-calendar-desc":
          "Chaque membre de l'équipe a accès, depuis son propre compte, au calendrier de l’entreprise de planification des déplacements et poses. Ajouter Google Calendar ou Microsoft Outlook.",
        "client-relations-title": "Relation client et CRM",
        "client-relations-desc":
          "Attribution de clients, espace commentaires sur fiches clients, stockage de fichiers. Notifications réglables par email automatiques.",
        "team-access-title": "Accès et rôles équipes",
        "team-access-desc":
          "Les commerciaux, le secrétariat et les techniciens peuvent personnaliser chacun leur interface. Les gérants ont accès aux paiements. La comptabilité à accès via email aux factures.",
        "integration-business-referrers-title":
          "Intégration avec les apporteurs d’affaires",
        "integration-business-referrers-desc":
          "Les apporteurs d'affaires n'ont accès qu'à leur clients. La visibilité des informations est personnalisable.",
        "custom-dashboard-title": "Tableau de bord personnalisable",
        "custom-dashboard-desc":
          "Chaque membre de votre équipe peut régler son tableau de bord. Gérez votre dimensionnement, études, démarches administratives, et construction dans un seul endroit.",
        "sales-cycle-tracking-title": "Suivi et rapports du cycle de vente",
        "sales-cycle-tracking-desc":
          "Visualisez les chiffrés clés de vos ventes et votre activité en temps réel. Notre plateforme génère les statistiques de vos chantiers. Recevez des rapports automatiques par email.",
        "data-export-title": "Export des données",
        "data-export-desc":
          "Besoin d’analyser les données sur Excel ? Besoin de sécuriser les données ? Exportez tous les tableaux et dossiers en CSV.",
        "as-built-files-title": "Dossiers Ouvrage Exécutés (DOE) automatiques",
        "as-built-files-desc":
          "Générez les rapports DOE en PDF ou en web, partageables aux clients et tiers pour PV de réception des travaux et audits assurances.",
        "maintenance-contracts-title": "Contrats de maintenance",
        "maintenance-contracts-desc":
          "Aidez vos clients à planifier et payer sur pages de paiement en ligne des interventions de SAV et contrats de maintenance.",
        "white-label-100-title": "100% en marque blanche",
        "white-label-100-desc":
          "Ajoutez votre logo et les couleurs principales, de boutons et des graphiques. Personnalisez les interfaces. Valorisez votre marque.",
        "white-label-client-portal-title": "Portail client en marque blanche",
        "white-label-client-portal-desc":
          "Invitez vos clients à un espace en ligne pour visualiser votre étude, signer votre devis, et suivre l’avancement de leur dossier. Vos clients peuvent renseigner informations et documents.",
        "login-registration-pages-title":
          "Pages de connexion et d’inscription sur site internet",
        "login-registration-pages-desc":
          "Invitez vos clients à se connecter sur leur espace client en marque blanche depuis votre site internet.",
        "seo-title": "Référencement moteur de recherche et SEO",
        "seo-desc":
          "Renseignez le profil personnalisable « Notre établissement » disponible sur études et sur notre annuaire.",
        "online-messaging-title": "Messagerie en ligne",
        "online-messaging-desc":
          "Notre équipe répond dans les minutes qui suivent avec traces écrites.",
        "phone-support-title": "Téléphonie",
        "phone-support-desc":
          "Notre équipe est toujours joignable pour vous accompagner dans vos démarches.",
        "email-title": "Email",
        "email-desc":
          "Notre équipe est disponible par email pour faciliter vos échanges avec les tiers.",
        "video-conference-appointments-title":
          "Rendez-vous en visio-conférence",
        "video-conference-appointments-desc":
          "Notre équipe est à votre écoute pour développer ensemble votre suivi.",
        "file-transfer-title": "Transfert des dossiers",
        "file-transfer-desc":
          "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
      },
    },
    REGIONAL: {
      hero: {
        "icon-label": "Études de cas",
        "discover-solutions": "Découvrir solutions",
        "book-demo": "Demander une démo",
        "name-orange": "PME locale",
        "name-black": "valorisant son image de marque",
        description:
          "Vous êtes un installateur photovoltaïque opérant dans plusieurs départements ? Découvrez comment les professionnels utilisent projetsolaire pour simplifier leur quotidien.",
      },
      works: {
        heading: "Comment ça marche",
        title:
          "Bureau d’études numérique conçu pour les équipes photovoltaïques.",

        steps: {
          step1: {
            title: "Ouverture du compte",
            heading:
              "Sans engagement. Inscription rapide et gratuite en ligne. Puis, complétez le compte avec décennale, RGE et autres documents.",
          },
          step2: {
            title: "Inviter l’équipe",
            heading:
              "Renseignez vos coéquipiers en quelques clics. Gérez les rôles et les accès de vos équipes. Pilotez les clients, chantiers et déplacements.",
          },
          step3: {
            title: "Formations de démarrage",
            heading:
              "Vos équipes sont formées par nos équipes aux solutions informatiques. Nos équipes vous accompagnent dans les intégrations informatiques.",
          },
        },
      },
      "product-listing": {
        title: "Solutions tout-en-un et à la carte",
        description:
          "Découvrez la solution de référence de la filière photovoltaïque, reconnue comme N°1 par des centaines de clients.",
        button: "En savoir plus",
        connection: "Mise en relation",
        "connection-desc":
          "Découvrez des clients potentiels directement depuis votre compte, sans payer de commissions d’apporteurs d’affaires.",
        "project-management-assistance-title":
          "Assistance de maîtrise d’ouvrage",
        "project-management-assistance-desc":
          "Le maître d’œuvre fixe le prix et le matériel. Bénéficiez des outils visite technique et signature électronique pour accélérer vos ventes",
        "3d-sizing-tool-title": "Outil de Dimensionnement en 3D",
        "3d-sizing-tool-desc":
          "Nous avons intégré Aurora Solar pour vous offrir la solution la plus puissante et techniquement précise de productible photovoltaïque.",
        "shading-masks-compliant-with-rge-audit-title":
          "Masques d’ombrages conforme à l’audit RGE",
        "shading-masks-compliant-with-rge-audit-desc":
          "Optez pour la précision du LIDAR au 0,10m en 3D pour réaliser des évaluations de l’ensoleillement au kWh/m² partout en France.",
        "enedis-api-title": "API Enedis et Données du compteur Linky",
        "enedis-api-desc":
          "Analysez l'autoconsommation électrique de vos clients au travers de leurs historique horaire de consommation en kWh.",
        "self-consumption-title":
          "Études en autoconsommation ou vente en totalité",
        "self-consumption-desc":
          "Proposez des études extraordinaires et complètes, avec nombre illimité de propositions technico-financières par études.",
        "virtual-battery-title": "Études comparative Batterie Virtuelle",
        "virtual-battery-desc":
          "Comparez la rentabilité du contrat EDF OA avec les fournisseurs de batterie virtuelle MyLight Systems, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Études de batterie physique",
        "physical-battery-studies-desc":
          "Ajoutez un modèle de batterie physique et fiche technique pour analyse horaire de l’autoconsommation et de la rentabilité du stockage.",
        "profitability-studies-title":
          "Études technico-financières de rentabilité",
        "profitability-studies-desc":
          "Définissez le business plan du budget. Calcul des prévisionnels financiers sur 25 ans. Analysez le tableau des flux de trésorerie de l’investissement sur la durée de vie du projet.",
        "edf-oa-purchase-tariff-title":
          "Veuille du tarif d’achat EDF OA en métropole et ZNI",
        "edf-oa-purchase-tariff-desc":
          "Les primes d’État et tarifs d’achat de nos études sont mise à jour tous les trimestres avec les nouveaux arrêté tarifaires de la CRE.",
        "purchase-tariff-comparison-title":
          "Comparatif destarifs d’achat par T-0",
        "purchase-tariff-comparison-desc":
          "Comparez la rentabilité des centrales photovoltaïques par rapport aux aides de l’État sur les différents trimestres pour accélérer vos ventes.",
        "credit-financing-simulator-title":
          "Simulateur de crédit et financement",
        "credit-financing-simulator-desc":
          "Analysez l’investissement au comptant, au travers d’un crédit, ou bien de location de toiture - directement intégré dans l’étude.",
        "enedis-costs-simulator-title": "Simulateur des coûts d’Enedis",
        "enedis-costs-simulator-desc":
          "Estimez les coûts de renforcement du réseau électrique à partir du Barème de facturation d’Enedis. La seule alternative au PTF en France.",
        "white-label-support-formats-title":
          "Tous les formats de support en marque blanche",
        "white-label-support-formats-desc":
          "Études en mini-site interactif internet ou PDF ou feuille de calcul ou mobile.",
        "quotes-with-integrated-hardware-title": "Devis avec matériel intégré",
        "quotes-with-integrated-hardware-desc":
          "Préparez vos devis à partir d'une base de données avec milliers de modules, onduleurs, coffrets, batterie.",
        "accounting-numbering-of-quotes-title":
          "Numérotation comptable des devis",
        "accounting-numbering-of-quotes-desc":
          "Personnalisez aussi vos couleurs, vos CGV, fiches techniques, attestation TVA, et bien plus encore de vos devis.",
        "electronic-signature-title": "Signatures électroniques conformes",
        "electronic-signature-desc":
          "Rédigez puis faites signer en ligne vos devis, avec vos références et mentions. Retrouvez vos devis et documents sur votre compte.",

        "accounting-invoices-for-deposits-and-balances-title":
          "Factures comptables pour acomptes et soldes",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Définissez vos acomptes, gérer vos transactions, ajouter vos factures, et bien plus encore.",
        "secure-payments-title":
          "Paiements sécurisés par virement ou carte bancaire",
        "secure-payments-desc":
          "Percevez vos revenus via des pages de paiements simples, avec plusieurs modes de paiement, intégrées aux devis et factures.",
        "product-references-title":
          "10000+ références produits : modules, onduleurs, coffrets, batteries ...",
        "product-references-desc":
          "Choisissez le modèle de produit depuis notre base de données mise à jour en temps réel. Sauvegardez vos kits et listes de matériel pour saisie réduite des devis et démarches.",
        "construction-site-equipment-lists-title":
          "Listes de matériel des chantiers",
        "construction-site-equipment-lists-desc":
          "Planification automatique des listes de produits et équipements pour installations photovoltaïque.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Fiches techniques et Certificats de conformités et Bilan carbone",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Notre base de données contient des milliers de documents à jour pour vos démarches.",
        "professional-technical-documentation-title":
          "Documentation technique professionnelle",
        "professional-technical-documentation-desc":
          "Générez automatiquement des schémas de câblage, Attestations de bridage, et Plans d’exécution.",
        "material-ordering-title": "Commande du matériel",
        "material-ordering-desc":
          "Demandez des devis des fabricants et distributeurs pour trouver des prix compétitifs en ligne.",
        "urban-planning-authorization-requests-title":
          "Demandes d’autorisation d’urbanisme",
        "urban-planning-authorization-requests-desc":
          "La réalisation de la Déclaration Préalable ou Permis de Construire pour votre installation photovoltaïque auprès des institutions locales compétentes pour accord en mairie.",
        "gracious-appeal-title": "Recours gracieux et DAACT",
        "gracious-appeal-desc":
          "La réalisation du DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes. En cas de refus, réalisation du recours gracieux.",
        "architect-communication-title": "Interlocution avec architectes",
        "architect-communication-desc":
          "La réalisation des études de faisabilité de PLU/RNU, préparation des pièces graphiques, de l’attestation architecte, du dépôt en mairie en obligation architecte.",
        "connection-requests-title": "Demandes de raccordement",
        "connection-requests-desc":
          "L’obtention du contrat CAE et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "low-or-medium-voltage-connection-requests-title":
          "Demandes de raccordement en BT ou HTA",
        "low-or-medium-voltage-connection-requests-desc":
          "L’obtention du PTF puis contrat CACS-i et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "collective-self-consumption-connection-requests-title":
          "Demandes de raccordement Autoconsommation Collective",
        "collective-self-consumption-connection-requests-desc":
          "Notre partenaire spécialisé est intégré directement dans votre compte pour création communauté et PMO. Réalisation des demandes CAE et clés de répartition.",
        "consuel-certificate-title":
          "Demandes de visa de l’Attestation Consuel",
        "consuel-certificate-desc":
          "La réalisation du SC144-A ou SC144-B ou SC144-C, la réalisation du Schéma unifilaire électrique, puis dépôt de l’Attestation de conformité Bleu ou Violette (pour batteries).",
        "control-office-title": "Bureau de contrôle et visa Consuel",
        "control-office-desc":
          "L’interlocution technique avec organismes agréés et obtention du rapport DRE de conformité. La réalisation du SC144, Schéma unifilaire électrique, puis dépôt de l’AC Bleu ou Violette.",
        "large-scale-sending-title": "Envoi en 48 heures à grande échelle",
        "large-scale-sending-desc":
          "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
        "real-time-tracking-title": "Suivi daté en temps réel",
        "real-time-tracking-desc":
          "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
        "additional-docs-title":
          "Traitement des demandes de pièces complémentaires",
        "additional-docs-desc":
          "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
        "follow-ups-title": "Relances aux instances administratives",
        "follow-ups-desc":
          "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        "edf-obligation-title": "EDF Obligation Achat",
        "edf-obligation-desc":
          "La réalisation de la démarche auprès d’EDF OA, Attestation sur l’honneur automatique ou bien l’Attestation S21 ‘ENR’ avec Bilan Carbone (au delà de 100 kWc).",
        "virtual-battery-procedure-title": "Démarche Batterie virtuelle",
        "virtual-battery-procedure-desc":
          "La réalisation de la démarche auprès d’un des trois fournisseurs de batterie virtuelle - MyLight Systems, Urban Solar Energy, JPME - pour stockage virtuel.",
        "financing-report-title": "Dossier de rentabilité de financement",
        "financing-report-desc":
          "Analysez le financement de l’investissement photovoltaïque par rapport au rendement énergétique, à partir d’un calcul horaire en kWh.",
        "payment-savings-title": "Calcul de mensualité et effort d’épargne",
        "payment-savings-desc":
          "Comparez le financement de l'investissement photovoltaïque, que ce soit en espèces ou par un prêt bancaire, en intégrant votre OPEX et EBITDA.",
        "solar-subscription-title": "Abonnement solaire",
        "solar-subscription-desc":
          "Notre partenaire spécialisé dans l’abonnement est intégré directement dans votre compte. Faites les demandes de financement par abonnement solaire dès l’étude.",
        "creation-and-management-of-spvs-title": "Création et gestion des SPV",
        "creation-and-management-of-spvs-desc":
          "Votre équipe organise les portefeuilles de chantiers par SPV directement depuis votre compte. Nos chargés de projets peuvent créer les SIRET et accompagner auprès des notaires.",
        "mobile-assistance-title": "Assistance mobile de visite technique",
        "mobile-assistance-desc":
          "Vos technico-commerciaux peuvent facilement renseigner les fiches clients et télécharger les photos et infos en déplacement.",
        "hardware-planning-title": "Planification du matériel",
        "hardware-planning-desc":
          "Listes automatiques d'inventaire des équipements des chantiers disponibles par chantier et par flux, pour contrôle du matériel et des commandes.",
        "integrated-calendar-title": "Agenda intégré",
        "integrated-calendar-desc":
          "Chaque membre de l'équipe a accès, depuis son propre compte, au calendrier de l’entreprise de planification des déplacements et poses. Ajouter Google Calendar ou Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Gestion de sous-traitants poseurs",
        "subcontractor-management-for-installers-desc":
          "Vos documents techniques sont partageables directement depuis votre compte avec vos partenaires maîtres d’œuvres, pour faciliter l’installation, Consuel et Bureau de contrôle.",
        "client-relations-title": "Relation client et CRM",
        "client-relations-desc":
          "Attribution de clients, espace commentaires sur fiches clients, stockage de fichiers. Notifications réglables par email automatiques.",
        "team-access-title": "Accès et rôles équipes",
        "team-access-desc":
          "Les commerciaux, le secrétariat et les techniciens peuvent personnaliser chacun leur interface. Les gérants ont accès aux paiements. La comptabilité à accès via email aux factures.",
        "integration-business-referrers-title":
          "Intégration avec les apporteurs d’affaires",
        "integration-business-referrers-desc":
          "Les apporteurs d'affaires n'ont accès qu'à leur clients. La visibilité des informations est personnalisable.",
        "custom-dashboard-title": "Tableau de bord personnalisable",
        "custom-dashboard-desc":
          "Chaque membre de votre équipe peut régler son tableau de bord. Gérez votre dimensionnement, études, démarches administratives, et construction dans un seul endroit.",
        "sales-cycle-tracking-title": "Suivi et rapports du cycle de vente",
        "sales-cycle-tracking-desc":
          "Visualisez les chiffrés clés de vos ventes et votre activité en temps réel. Notre plateforme génère les statistiques de vos chantiers. Recevez des rapports automatiques par email.",
        "data-export-title": "Export des données",
        "data-export-desc":
          "Besoin d’analyser les données sur Excel ? Besoin de sécuriser les données ? Exportez tous les tableaux et dossiers en CSV.",
        "as-built-files-title": "Dossiers Ouvrage Exécutés (DOE) automatiques",
        "as-built-files-desc":
          "Générez les rapports DOE en PDF ou en web, partageables aux clients et tiers pour PV de réception des travaux et audits assurances.",
        "maintenance-contracts-title": "Contrats de maintenance",
        "maintenance-contracts-desc":
          "Aidez vos clients à planifier et payer sur pages de paiement en ligne des interventions de SAV et contrats de maintenance.",
        "white-label-100-title": "100% en marque blanche",
        "white-label-100-desc":
          "Ajoutez votre logo et les couleurs principales, de boutons et des graphiques. Personnalisez les interfaces. Valorisez votre marque.",
        "white-label-client-portal-title": "Portail client en marque blanche",
        "white-label-client-portal-desc":
          "Invitez vos clients à un espace en ligne pour visualiser votre étude, signer votre devis, et suivre l’avancement de leur dossier. Vos clients peuvent renseigner informations et documents.",
        "login-registration-pages-title":
          "Pages de connexion et d’inscription sur site internet",
        "login-registration-pages-desc":
          "Invitez vos clients à se connecter sur leur espace client en marque blanche depuis votre site internet.",
        "seo-title": "Référencement moteur de recherche et SEO",
        "seo-desc":
          "Renseignez le profil personnalisable « Notre établissement » disponible sur études et sur notre annuaire.",
        "online-messaging-title": "Messagerie en ligne",
        "online-messaging-desc":
          "Notre équipe répond dans les minutes qui suivent avec traces écrites.",
        "phone-support-title": "Téléphonie",
        "phone-support-desc":
          "Notre équipe est toujours joignable pour vous accompagner dans vos démarches.",
        "email-title": "Email",
        "email-desc":
          "Notre équipe est disponible par email pour faciliter vos échanges avec les tiers.",
        "video-conference-appointments-title":
          "Rendez-vous en visio-conférence",
        "video-conference-appointments-desc":
          "Notre équipe est à votre écoute pour développer ensemble votre suivi.",
        "file-transfer-title": "Transfert des dossiers",
        "file-transfer-desc":
          "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
      },
    },
    NATIONAL: {
      hero: {
        "icon-label": "Études de cas",
        "discover-solutions": "Découvrir solutions",
        "book-demo": "Demander une démo",
        "name-orange": "Acteur national",
        "name-black": "en quête d’excellence opérationnelle",
        description:
          "Vous êtes un acteur intervenant dans toute la France et réalisant de nombreux chantiers à l’échelle nationale ? Découvrez comment réduire votre coût au Wc grâce au numérique.",
      },
      works: {
        heading: "Comment ça marche",
        title:
          "Bureau d’études numérique adapté pour une gestion sur toute la France.",

        steps: {
          step1: {
            title: "Ouverture du compte",
            heading:
              "Sans engagement. Inscription rapide et gratuite en ligne. Puis, personnalisez vos couleurs, votre présentation d’établissement et votre image de marque.",
          },
          step2: {
            title: "Transfert des dossiers",
            heading:
              "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
          },
          step3: {
            title: "Démarrage Comité de Pilotage",
            heading:
              "Organisation du service autour de rapports détaillés et rendez-vous bimensuels avec un seul interlocuteur et des chargés de projets.",
          },
        },
      },
      "product-listing": {
        title: "Solutions tout-en-un et à la carte",
        description:
          "Découvrez la solution de référence de la filière photovoltaïque, reconnue comme N°1 par des centaines de clients.",
        button: "En savoir plus",
        "bi-monthly-steering-committee-title": "Comité de Pilotage bimensuel",
        "bi-monthly-steering-committee-desc":
          "Organisation du service autour de rapports détaillés et rendez-vous tous les 15 jours avec un seul interlocuteur et des chargés de projets.",
        "exclusive-access-title": "Accès privilégié",
        "exclusive-access-desc": "Vos équipes clés sont invités à rejoindre.",
        connection: "Mise en relation",
        "connection-desc":
          "Découvrez des clients potentiels directement depuis votre compte, sans payer de commissions d’apporteurs d’affaires.",
        "project-management-assistance-title":
          "Assistance de maîtrise d’ouvrage",
        "project-management-assistance-desc":
          "Le maître d’œuvre fixe le prix et le matériel. Bénéficiez des outils visite technique et signature électronique pour accélérer vos ventes",
        "3d-sizing-tool-title": "Outil de Dimensionnement en 3D",
        "3d-sizing-tool-desc":
          "Nous avons intégré Aurora Solar pour vous offrir la solution la plus puissante et techniquement précise de productible photovoltaïque.",
        "shading-masks-compliant-with-rge-audit-title":
          "Masques d’ombrages conforme à l’audit RGE",
        "shading-masks-compliant-with-rge-audit-desc":
          "Optez pour la précision du LIDAR au 0,10m en 3D pour réaliser des évaluations de l’ensoleillement au kWh/m² partout en France.",
        "technical-design-pv-syst-title": "Conception technique avec PV SYST",
        "technical-design-pv-syst-desc":
          "Les ingénieurs électriques de notre bureau d’études réalisent la conception des onduleurs et optimisation Pnom, P50-P95 de chantiers.",
        "enedis-api-title": "API Enedis et Données du compteur Linky",
        "enedis-api-desc":
          "Analysez l'autoconsommation électrique de vos clients au travers de leurs historique horaire de consommation en kWh.",
        "self-consumption-title":
          "Études en autoconsommation ou vente en totalité",
        "self-consumption-desc":
          "Proposez des études extraordinaires et complètes, avec nombre illimité de propositions technico-financières par études.",
        "virtual-battery-title": "Études comparative Batterie Virtuelle",
        "virtual-battery-desc":
          "Comparez la rentabilité du contrat EDF OA avec les fournisseurs de batterie virtuelle MyLight Systems, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Études de batterie physique",
        "physical-battery-studies-desc":
          "Ajoutez un modèle de batterie physique et fiche technique pour analyse horaire de l’autoconsommation et de la rentabilité du stockage.",
        "profitability-studies-title":
          "Études technico-financières de rentabilité",
        "profitability-studies-desc":
          "Définissez le business plan du budget. Calcul des prévisionnels financiers sur 25 ans. Analysez le tableau des flux de trésorerie de l’investissement sur la durée de vie du projet.",
        "edf-oa-purchase-tariff-title":
          "Veuille du tarif d’achat EDF OA en métropole et ZNI",
        "edf-oa-purchase-tariff-desc":
          "Les primes d’État et tarifs d’achat de nos études sont mise à jour tous les trimestres avec les nouveaux arrêté tarifaires de la CRE.",
        "purchase-tariff-comparison-title":
          "Comparatif destarifs d’achat par T-0",
        "purchase-tariff-comparison-desc":
          "Comparez la rentabilité des centrales photovoltaïques par rapport aux aides de l’État sur les différents trimestres pour accélérer vos ventes.",
        "enedis-costs-simulator-title": "Simulateur des coûts d’Enedis",
        "enedis-costs-simulator-desc":
          "Estimez les coûts de renforcement du réseau électrique à partir du Barème de facturation d’Enedis. La seule alternative au PTF en France.",
        "white-label-support-formats-title":
          "Tous les formats de support en marque blanche",
        "white-label-support-formats-desc":
          "Études en mini-site interactif internet ou PDF ou feuille de calcul ou mobile.",
        "quotes-with-integrated-hardware-title": "Devis avec matériel intégré",
        "quotes-with-integrated-hardware-desc":
          "Préparez vos devis à partir d'une base de données avec milliers de modules, onduleurs, coffrets, batterie.",
        "accounting-numbering-of-quotes-title":
          "Numérotation comptable des devis",
        "accounting-numbering-of-quotes-desc":
          "Personnalisez aussi vos couleurs, vos CGV, fiches techniques, attestation TVA, et bien plus encore de vos devis.",
        "electronic-signature-title": "Signatures électroniques conformes",
        "electronic-signature-desc":
          "Rédigez puis faites signer en ligne vos devis, avec vos références et mentions. Retrouvez vos devis et documents sur votre compte.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Factures comptables pour acomptes et soldes",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Définissez vos acomptes, gérer vos transactions, ajouter vos factures, et bien plus encore.",
        "secure-payments-title":
          "Paiements sécurisés par virement ou carte bancaire",
        "secure-payments-desc":
          "Percevez vos revenus via des pages de paiements simples, avec plusieurs modes de paiement, intégrées aux devis et factures.",
        "product-references-title":
          "10000+ références produits : modules, onduleurs, coffrets, batteries ...",
        "product-references-desc":
          "Choisissez le modèle de produit depuis notre base de données mise à jour en temps réel. Sauvegardez vos kits et listes de matériel pour saisie réduite des devis et démarches.",
        "construction-site-equipment-lists-title":
          "Listes de matériel des chantiers",
        "construction-site-equipment-lists-desc":
          "Planification automatique des listes de produits et équipements pour installations photovoltaïque.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Fiches techniques et Certificats de conformités et Bilan carbone",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Notre base de données contient des milliers de documents à jour pour vos démarches.",
        "professional-technical-documentation-title":
          "Documentation technique professionnelle",
        "professional-technical-documentation-desc":
          "Générez automatiquement des schémas de câblage, Attestations de bridage, et Plans d’exécution.",
        "material-ordering-title": "Commande du matériel",
        "material-ordering-desc":
          "Demandez des devis des fabricants et distributeurs pour trouver des prix compétitifs en ligne.",
        "urban-planning-authorization-requests-title":
          "Demandes d’autorisation d’urbanisme",
        "urban-planning-authorization-requests-desc":
          "La réalisation de la Déclaration Préalable ou Permis de Construire pour votre installation photovoltaïque auprès des institutions locales compétentes pour accord en mairie.",
        "gracious-appeal-title": "Recours gracieux et DAACT",
        "gracious-appeal-desc":
          "La réalisation du DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes. En cas de refus, réalisation du recours gracieux.",
        "architect-communication-title": "Interlocution avec architectes",
        "architect-communication-desc":
          "La réalisation des études de faisabilité de PLU/RNU, préparation des pièces graphiques, de l’attestation architecte, du dépôt en mairie en obligation architecte.",
        "building-permit-expiry-title": "Purge de Permis de construire",
        "building-permit-expiry-desc":
          "La réalisation du DOC, interlocution puis réalisation des Constats huissier, EDDV, puis DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes.",
        "preliminary-declarations-small-land-title":
          "Déclarations préalables ‘Petit sol’",
        "preliminary-declarations-small-land-desc":
          "La réalisation des études de faisabilité de PLU/RNU, réalisation Fiche agricole, Étude de cas par cas, du dépôt en mairie de la Déclaration Préalable.",
        "connection-requests-title": "Demandes de raccordement",
        "connection-requests-desc":
          "L’obtention du contrat CAE et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "low-or-medium-voltage-connection-requests-title":
          "Demandes de raccordement en BT ou HTA",
        "low-or-medium-voltage-connection-requests-desc":
          "L’obtention du PTF puis contrat CACS-i et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "collective-self-consumption-connection-requests-title":
          "Demandes de raccordement Autoconsommation Collective",
        "collective-self-consumption-connection-requests-desc":
          "Notre partenaire spécialisé est intégré directement dans votre compte pour création communauté et PMO. Réalisation des demandes CAE et clés de répartition.",
        "consuel-certificate-title":
          "Demandes de visa de l’Attestation Consuel",
        "consuel-certificate-desc":
          "La réalisation du SC144-A ou SC144-B ou SC144-C, la réalisation du Schéma unifilaire électrique, puis dépôt de l’Attestation de conformité Bleu ou Violette (pour batteries).",
        "control-office-title": "Bureau de contrôle et visa Consuel",
        "control-office-desc":
          "L’interlocution technique avec organismes agréés et obtention du rapport DRE de conformité. La réalisation du SC144, Schéma unifilaire électrique, puis dépôt de l’AC Bleu ou Violette.",
        "large-scale-sending-title": "Envoi en 48 heures à grande échelle",
        "large-scale-sending-desc":
          "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
        "real-time-tracking-title": "Suivi daté en temps réel",
        "real-time-tracking-desc":
          "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
        "additional-docs-title":
          "Traitement des demandes de pièces complémentaires",
        "additional-docs-desc":
          "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
        "follow-ups-title": "Relances aux instances administratives",
        "follow-ups-desc":
          "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        "edf-obligation-title": "EDF Obligation Achat",
        "edf-obligation-desc":
          "La réalisation de la démarche auprès d’EDF OA, Attestation sur l’honneur automatique ou bien l’Attestation S21 ‘ENR’ avec Bilan Carbone (au delà de 100 kWc).",
        "arpe-procedure-title": "Démarche ARPE",
        "arpe-procedure-desc":
          "La réalisation de la démarche auprès d’un acheteur alternatif - Octopus Energie, Ekwateur, etc. - pour contrats PPE et autres contrats d’achat.",
        "virtual-battery-procedure-title": "Démarche Batterie virtuelle",
        "virtual-battery-procedure-desc":
          "La réalisation de la démarche auprès d’un des trois fournisseurs de batterie virtuelle - MyLight Systems, Urban Solar Energy, JPME - pour stockage virtuel.",
        "financing-report-title": "Dossier de rentabilité de financement",
        "financing-report-desc":
          "Analysez le financement de l’investissement photovoltaïque par rapport au rendement énergétique, à partir d’un calcul horaire en kWh.",
        "payment-savings-title": "Calcul de mensualité et effort d’épargne",
        "payment-savings-desc":
          "Comparez le financement de l'investissement photovoltaïque, que ce soit en espèces ou par un prêt bancaire, en intégrant votre OPEX et EBITDA.",
        "solar-subscription-title": "Abonnement solaire",
        "solar-subscription-desc":
          "Notre partenaire spécialisé dans l’abonnement est intégré directement dans votre compte. Faites les demandes de financement par abonnement solaire dès l’étude.",
        "creation-and-management-of-spvs-title": "Création et gestion des SPV",
        "creation-and-management-of-spvs-desc":
          "Votre équipe organise les portefeuilles de chantiers par SPV directement depuis votre compte. Nos chargés de projets peuvent créer les SIRET et accompagner auprès des notaires.",
        "mobile-assistance-title": "Assistance mobile de visite technique",
        "mobile-assistance-desc":
          "Vos technico-commerciaux peuvent facilement renseigner les fiches clients et télécharger les photos et infos en déplacement.",
        "hardware-planning-title": "Planification du matériel",
        "hardware-planning-desc":
          "Listes automatiques d'inventaire des équipements des chantiers disponibles par chantier et par flux, pour contrôle du matériel et des commandes.",
        "integrated-calendar-title": "Agenda intégré",
        "integrated-calendar-desc":
          "Chaque membre de l'équipe a accès, depuis son propre compte, au calendrier de l’entreprise de planification des déplacements et poses. Ajouter Google Calendar ou Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Gestion de sous-traitants poseurs",
        "subcontractor-management-for-installers-desc":
          "Vos documents techniques sont partageables directement depuis votre compte avec vos partenaires maîtres d’œuvres, pour faciliter l’installation, Consuel et Bureau de contrôle.",
        "client-relations-title": "Relation client et CRM",
        "client-relations-desc":
          "Attribution de clients, espace commentaires sur fiches clients, stockage de fichiers. Notifications réglables par email automatiques.",
        "team-access-title": "Accès et rôles équipes",
        "team-access-desc":
          "Les commerciaux, le secrétariat et les techniciens peuvent personnaliser chacun leur interface. Les gérants ont accès aux paiements. La comptabilité à accès via email aux factures.",
        "integration-business-referrers-title":
          "Intégration avec les apporteurs d’affaires",
        "integration-business-referrers-desc":
          "Les apporteurs d'affaires n'ont accès qu'à leur clients. La visibilité des informations est personnalisable.",
        "custom-dashboard-title": "Tableau de bord personnalisable",
        "custom-dashboard-desc":
          "Chaque membre de votre équipe peut régler son tableau de bord. Gérez votre dimensionnement, études, démarches administratives, et construction dans un seul endroit.",
        "sales-cycle-tracking-title": "Suivi et rapports du cycle de vente",
        "sales-cycle-tracking-desc":
          "Visualisez les chiffrés clés de vos ventes et votre activité en temps réel. Notre plateforme génère les statistiques de vos chantiers. Recevez des rapports automatiques par email.",
        "data-export-title": "Export des données",
        "data-export-desc":
          "Besoin d’analyser les données sur Excel ? Besoin de sécuriser les données ? Exportez tous les tableaux et dossiers en CSV.",
        "as-built-files-title": "Dossiers Ouvrage Exécutés (DOE) automatiques",
        "as-built-files-desc":
          "Générez les rapports DOE en PDF ou en web, partageables aux clients et tiers pour PV de réception des travaux et audits assurances.",
        "maintenance-contracts-title": "Contrats de maintenance",
        "maintenance-contracts-desc":
          "Aidez vos clients à planifier et payer sur pages de paiement en ligne des interventions de SAV et contrats de maintenance.",
        "white-label-100-title": "100% en marque blanche",
        "white-label-100-desc":
          "Ajoutez votre logo et les couleurs principales, de boutons et des graphiques. Personnalisez les interfaces. Valorisez votre marque.",
        "white-label-client-portal-title": "Portail client en marque blanche",
        "white-label-client-portal-desc":
          "Invitez vos clients à un espace en ligne pour visualiser votre étude, signer votre devis, et suivre l’avancement de leur dossier. Vos clients peuvent renseigner informations et documents.",
        "login-registration-pages-title":
          "Pages de connexion et d’inscription sur site internet",
        "login-registration-pages-desc":
          "Invitez vos clients à se connecter sur leur espace client en marque blanche depuis votre site internet.",
        "seo-title": "Référencement moteur de recherche et SEO",
        "seo-desc":
          "Renseignez le profil personnalisable « Notre établissement » disponible sur études et sur notre annuaire.",
        "online-messaging-title": "Messagerie en ligne",
        "online-messaging-desc":
          "Notre équipe répond dans les minutes qui suivent avec traces écrites.",
        "phone-support-title": "Téléphonie",
        "phone-support-desc":
          "Notre équipe est toujours joignable pour vous accompagner dans vos démarches.",
        "email-title": "Email",
        "email-desc":
          "Notre équipe est disponible par email pour faciliter vos échanges avec les tiers.",
        "video-conference-appointments-title":
          "Rendez-vous en visio-conférence",
        "video-conference-appointments-desc":
          "Notre équipe est à votre écoute pour développer ensemble votre suivi.",
        "file-transfer-title": "Transfert des dossiers",
        "file-transfer-desc":
          "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
      },
    },
    SELF_INSTALLATION: {
      hero: {
        "icon-label": "Études de cas",
        "discover-solutions": "Découvrir solutions",
        "book-demo": "Demander une démo",
        "name-orange": "Marque en ligne",
        "name-black": "proposant des services",
        description:
          "Vous êtes une société proposant une solution plug & play (kit solaire) ou DIY (Do It Yourself) à travers la France ? Découvrez comment vendre des services d’accompagnement en ligne.",
      },
      works: {
        heading: "Comment ça marche",
        title:
          "Bureau d’études numérique adapté à la vente innovante et 100% en ligne.",

        steps: {
          step1: {
            title: "Personnalisation du compte",
            heading:
              "Inscription rapide et gratuite en ligne. Sans engagement. Puis, personnalisez vos couleurs, votre présentation d’établissement et votre image de marque.",
          },
          step2: {
            title: "Intégration en marque blanche",
            heading:
              "Nos équipes informatiques vous accompagnent pour intégrer les pages d’inscription, de connexion et le portail client photovoltaïque à votre site internet.",
          },
          step3: {
            title: "Ajouter prestation à la carte",
            heading:
              "Besoin de faire des calepinages ? Des études complètes avec devis ? Ou bien des accords mairie ? Utilisez uniquement ce dont vous avez besoin.",
          },
        },
      },
      "product-listing": {
        title: "Solutions tout-en-un et à la carte",
        description:
          "Découvrez la solution de référence de la filière photovoltaïque, reconnue comme N°1 par des centaines de clients.",
        button: "En savoir plus",
        connection: "Mise en relation",
        "connection-desc":
          "Découvrez des clients potentiels directement depuis votre compte, sans payer de commissions d’apporteurs d’affaires.",
        "project-management-assistance-title":
          "Assistance de maîtrise d’ouvrage",
        "project-management-assistance-desc":
          "Le maître d’œuvre fixe le prix et le matériel. Bénéficiez des outils visite technique et signature électronique pour accélérer vos ventes",
        "3d-sizing-tool-title": "Outil de Dimensionnement en 3D",
        "3d-sizing-tool-desc":
          "Nous avons intégré Aurora Solar pour vous offrir la solution la plus puissante et techniquement précise de productible photovoltaïque.",
        "shading-masks-compliant-with-rge-audit-title":
          "Masques d’ombrages conforme à l’audit RGE",
        "shading-masks-compliant-with-rge-audit-desc":
          "Optez pour la précision du LIDAR au 0,10m en 3D pour réaliser des évaluations de l’ensoleillement au kWh/m² partout en France.",
        "enedis-api-title": "API Enedis et Données du compteur Linky",
        "enedis-api-desc":
          "Analysez l'autoconsommation électrique de vos clients au travers de leurs historique horaire de consommation en kWh.",
        "self-consumption-title":
          "Études en autoconsommation ou vente en totalité",
        "self-consumption-desc":
          "Proposez des études extraordinaires et complètes, avec nombre illimité de propositions technico-financières par études.",
        "virtual-battery-title": "Études comparative Batterie Virtuelle",
        "virtual-battery-desc":
          "Comparez la rentabilité du contrat EDF OA avec les fournisseurs de batterie virtuelle MyLight Systems, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Études de batterie physique",
        "physical-battery-studies-desc":
          "Ajoutez un modèle de batterie physique et fiche technique pour analyse horaire de l’autoconsommation et de la rentabilité du stockage.",
        "profitability-studies-title":
          "Études technico-financières de rentabilité",
        "profitability-studies-desc":
          "Définissez le business plan du budget. Calcul des prévisionnels financiers sur 25 ans. Analysez le tableau des flux de trésorerie de l’investissement sur la durée de vie du projet.",
        "edf-oa-purchase-tariff-title":
          "Veuille du tarif d’achat EDF OA en métropole et ZNI",
        "edf-oa-purchase-tariff-desc":
          "Les primes d’État et tarifs d’achat de nos études sont mise à jour tous les trimestres avec les nouveaux arrêté tarifaires de la CRE.",
        "credit-financing-simulator-title":
          "Simulateur de crédit et financement",
        "credit-financing-simulator-desc":
          "Analysez l’investissement au comptant, au travers d’un crédit, ou bien de location de toiture - directement intégré dans l’étude.",
        "white-label-support-formats-title":
          "Tous les formats de support en marque blanche",
        "white-label-support-formats-desc":
          "Études en mini-site interactif internet ou PDF ou feuille de calcul ou mobile.",
        "quotes-with-integrated-hardware-title": "Devis avec matériel intégré",
        "quotes-with-integrated-hardware-desc":
          "Préparez vos devis à partir d'une base de données avec milliers de modules, onduleurs, coffrets, batterie.",
        "accounting-numbering-of-quotes-title":
          "Numérotation comptable des devis",
        "accounting-numbering-of-quotes-desc":
          "Personnalisez aussi vos couleurs, vos CGV, fiches techniques, attestation TVA, et bien plus encore de vos devis.",
        "electronic-signature-title": "Signatures électroniques conformes",
        "electronic-signature-desc":
          "Rédigez puis faites signer en ligne vos devis, avec vos références et mentions. Retrouvez vos devis et documents sur votre compte.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Factures comptables pour acomptes et soldes",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Définissez vos acomptes, gérer vos transactions, ajouter vos factures, et bien plus encore.",
        "secure-payments-title":
          "Paiements sécurisés par virement ou carte bancaire",
        "secure-payments-desc":
          "Percevez vos revenus via des pages de paiements simples, avec plusieurs modes de paiement, intégrées aux devis et factures.",
        "product-references-title":
          "10000+ références produits : modules, onduleurs, coffrets, batteries ...",
        "product-references-desc":
          "Choisissez le modèle de produit depuis notre base de données mise à jour en temps réel. Sauvegardez vos kits et listes de matériel pour saisie réduite des devis et démarches.",
        "construction-site-equipment-lists-title":
          "Listes de matériel des chantiers",
        "construction-site-equipment-lists-desc":
          "Planification automatique des listes de produits et équipements pour installations photovoltaïque.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Fiches techniques et Certificats de conformités et Bilan carbone",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Notre base de données contient des milliers de documents à jour pour vos démarches.",
        "professional-technical-documentation-title":
          "Documentation technique professionnelle",
        "professional-technical-documentation-desc":
          "Générez automatiquement des schémas de câblage, Attestations de bridage, et Plans d’exécution.",
        "material-ordering-title": "Commande du matériel",
        "material-ordering-desc":
          "Demandez des devis des fabricants et distributeurs pour trouver des prix compétitifs en ligne.",
        "urban-planning-authorization-requests-title":
          "Demandes d’autorisation d’urbanisme",
        "urban-planning-authorization-requests-desc":
          "La réalisation de la Déclaration Préalable ou Permis de Construire pour votre installation photovoltaïque auprès des institutions locales compétentes pour accord en mairie.",
        "gracious-appeal-title": "Recours gracieux et DAACT",
        "gracious-appeal-desc":
          "La réalisation du DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes. En cas de refus, réalisation du recours gracieux.",
        "connection-requests-title": "Demandes de raccordement",
        "connection-requests-desc":
          "L’obtention du contrat CAE et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "collective-self-consumption-connection-requests-title":
          "Demandes de raccordement Autoconsommation Collective",
        "collective-self-consumption-connection-requests-desc":
          "Notre partenaire spécialisé est intégré directement dans votre compte pour création communauté et PMO. Réalisation des demandes CAE et clés de répartition.",
        "consuel-certificate-title":
          "Demandes de visa de l’Attestation Consuel",
        "consuel-certificate-desc":
          "La réalisation du SC144-A ou SC144-B ou SC144-C, la réalisation du Schéma unifilaire électrique, puis dépôt de l’Attestation de conformité Bleu ou Violette (pour batteries).",
        "large-scale-sending-title": "Envoi en 48 heures à grande échelle",
        "large-scale-sending-desc":
          "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
        "real-time-tracking-title": "Suivi daté en temps réel",
        "real-time-tracking-desc":
          "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
        "additional-docs-title":
          "Traitement des demandes de pièces complémentaires",
        "additional-docs-desc":
          "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
        "follow-ups-title": "Relances aux instances administratives",
        "follow-ups-desc":
          "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        "edf-obligation-title": "EDF Obligation Achat",
        "edf-obligation-desc":
          "La réalisation de la démarche auprès d’EDF OA, Attestation sur l’honneur automatique ou bien l’Attestation S21 ‘ENR’ avec Bilan Carbone (au delà de 100 kWc).",
        "cacsi-procedure-title": "Démarche CACSI",
        "cacsi-procedure-desc":
          "L’obtention du contrat CACSI et mise en service de votre installation photovoltaïque auprès du gestionnaire du réseau Enedis ou Régie locale ELD.",
        "arpe-procedure-title": "Démarche ARPE",
        "arpe-procedure-desc":
          "La réalisation de la démarche auprès d’un acheteur alternatif - Octopus Energie, Ekwateur, etc. - pour contrats PPE et autres contrats d’achat.",
        "virtual-battery-procedure-title": "Démarche Batterie virtuelle",
        "virtual-battery-procedure-desc":
          "La réalisation de la démarche auprès d’un des trois fournisseurs de batterie virtuelle - MyLight Systems, Urban Solar Energy, JPME - pour stockage virtuel.",
        "financing-report-title": "Dossier de rentabilité de financement",
        "financing-report-desc":
          "Analysez le financement de l’investissement photovoltaïque par rapport au rendement énergétique, à partir d’un calcul horaire en kWh.",
        "payment-savings-title": "Calcul de mensualité et effort d’épargne",
        "payment-savings-desc":
          "Comparez le financement de l'investissement photovoltaïque, que ce soit en espèces ou par un prêt bancaire, en intégrant votre OPEX et EBITDA.",
        "hardware-planning-title": "Planification du matériel",
        "hardware-planning-desc":
          "Listes automatiques d'inventaire des équipements des chantiers disponibles par chantier et par flux, pour contrôle du matériel et des commandes.",
        "integrated-calendar-title": "Agenda intégré",
        "integrated-calendar-desc":
          "Chaque membre de l'équipe a accès, depuis son propre compte, au calendrier de l’entreprise de planification des déplacements et poses. Ajouter Google Calendar ou Microsoft Outlook.",
        "sharing-sites-with-installers-title":
          "Partage des chantiers aux installateurs",
        "sharing-sites-with-installers-desc":
          "Vos documents techniques sont partageables directement depuis votre compte avec vos partenaires maîtres d’œuvres, pour faciliter la construction, Consuel et Bureau de contrôle.",
        "client-relations-title": "Relation client et CRM",
        "client-relations-desc":
          "Attribution de clients, espace commentaires sur fiches clients, stockage de fichiers. Notifications réglables par email automatiques.",
        "team-access-title": "Accès et rôles équipes",
        "team-access-desc":
          "Les commerciaux, le secrétariat et les techniciens peuvent personnaliser chacun leur interface. Les gérants ont accès aux paiements. La comptabilité à accès via email aux factures.",
        "integration-business-referrers-title":
          "Intégration avec les apporteurs d’affaires",
        "integration-business-referrers-desc":
          "Les apporteurs d'affaires n'ont accès qu'à leur clients. La visibilité des informations est personnalisable.",
        "custom-dashboard-title": "Tableau de bord personnalisable",
        "custom-dashboard-desc":
          "Chaque membre de votre équipe peut régler son tableau de bord. Gérez votre dimensionnement, études, démarches administratives, et construction dans un seul endroit.",
        "sales-cycle-tracking-title": "Suivi et rapports du cycle de vente",
        "sales-cycle-tracking-desc":
          "Visualisez les chiffrés clés de vos ventes et votre activité en temps réel. Notre plateforme génère les statistiques de vos chantiers. Recevez des rapports automatiques par email.",
        "data-export-title": "Export des données",
        "data-export-desc":
          "Besoin d’analyser les données sur Excel ? Besoin de sécuriser les données ? Exportez tous les tableaux et dossiers en CSV.",
        "as-built-files-title": "Dossiers Ouvrage Exécutés (DOE) automatiques",
        "as-built-files-desc":
          "Générez les rapports DOE en PDF ou en web, partageables aux clients et tiers pour PV de réception des travaux et audits assurances.",
        "maintenance-contracts-title": "Contrats de maintenance",
        "maintenance-contracts-desc":
          "Aidez vos clients à planifier et payer sur pages de paiement en ligne des interventions de SAV et contrats de maintenance.",
        "white-label-100-title": "100% en marque blanche",
        "white-label-100-desc":
          "Ajoutez votre logo et les couleurs principales, de boutons et des graphiques. Personnalisez les interfaces. Valorisez votre marque.",
        "white-label-client-portal-title": "Portail client en marque blanche",
        "white-label-client-portal-desc":
          "Invitez vos clients à un espace en ligne pour visualiser votre étude, signer votre devis, et suivre l’avancement de leur dossier. Vos clients peuvent renseigner informations et documents.",
        "login-registration-pages-title":
          "Pages de connexion et d’inscription sur site internet",
        "login-registration-pages-desc":
          "Invitez vos clients à se connecter sur leur espace client en marque blanche depuis votre site internet.",
        "seo-title": "Référencement moteur de recherche et SEO",
        "seo-desc":
          "Renseignez le profil personnalisable « Notre établissement » disponible sur études et sur notre annuaire.",
        "online-messaging-title": "Messagerie en ligne",
        "online-messaging-desc":
          "Notre équipe répond dans les minutes qui suivent avec traces écrites.",
        "phone-support-title": "Téléphonie",
        "phone-support-desc":
          "Notre équipe est toujours joignable pour vous accompagner dans vos démarches.",
        "email-title": "Email",
        "email-desc":
          "Notre équipe est disponible par email pour faciliter vos échanges avec les tiers.",
        "video-conference-appointments-title":
          "Rendez-vous en visio-conférence",
        "video-conference-appointments-desc":
          "Notre équipe est à votre écoute pour développer ensemble votre suivi.",
        "file-transfer-title": "Transfert des dossiers",
        "file-transfer-desc":
          "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
      },
    },
    FRANCHISE: {
      hero: {
        "icon-label": "Études de cas",
        "discover-solutions": "Découvrir solutions",
        "book-demo": "Demander une démo",
        "name-orange": "Réseau de franchises",
        "name-black": "à grande valeur ajoutée",
        description:
          "Vous êtes une société opérant en franchise sur l’ensemble du territoire national, intéressé par les chantiers du réseau de franchises ? Découvrez comment renforcer votre offre.",
      },
      works: {
        heading: "Comment ça marche",
        title:
          "Bureau d’études numérique conçu pour les équipes photovoltaïques.",

        steps: {
          step1: {
            title: "Ouverture du compte",
            heading:
              "Sans engagement. Inscription rapide et gratuite en ligne. Il suffit ensuite de renseigner les personnes clés de l’entreprise sur le compte.",
          },
          step2: {
            title: "Invitation des franchises",
            heading:
              "Nos équipes vous accompagnent dans les intégrations informatiques. Vos franchises sont formées par nos équipes aux solutions informatiques.",
          },
          step3: {
            title: "Partage des prestations",
            heading:
              "Achetez les solutions informatiques à la carte avec les avantages de la force du réseau. Gagnez ainsi de la valeur ajoutée pour vos franchises.",
          },
        },
      },
      "product-listing": {
        title: "Solutions tout-en-un et à la carte",
        description:
          "Découvrez la solution de référence de la filière photovoltaïque, reconnue comme N°1 par des centaines de clients.",
        button: "En savoir plus",
        connection: "Mise en relation",
        "connection-desc":
          "Découvrez des clients potentiels directement depuis votre compte, sans payer de commissions d’apporteurs d’affaires.",
        "project-management-assistance-title":
          "Assistance de maîtrise d’ouvrage",
        "project-management-assistance-desc":
          "Le maître d’œuvre fixe le prix et le matériel. Bénéficiez des outils visite technique et signature électronique pour accélérer vos ventes",
        "3d-sizing-tool-title": "Outil de Dimensionnement en 3D",
        "3d-sizing-tool-desc":
          "Nous avons intégré Aurora Solar pour vous offrir la solution la plus puissante et techniquement précise de productible photovoltaïque.",
        "shading-masks-compliant-with-rge-audit-title":
          "Masques d’ombrages conforme à l’audit RGE",
        "shading-masks-compliant-with-rge-audit-desc":
          "Optez pour la précision du LIDAR au 0,10m en 3D pour réaliser des évaluations de l’ensoleillement au kWh/m² partout en France.",
        "enedis-api-title": "API Enedis et Données du compteur Linky",
        "enedis-api-desc":
          "Analysez l'autoconsommation électrique de vos clients au travers de leurs historique horaire de consommation en kWh.",
        "self-consumption-title":
          "Études en autoconsommation ou vente en totalité",
        "self-consumption-desc":
          "Proposez des études extraordinaires et complètes, avec nombre illimité de propositions technico-financières par études.",
        "virtual-battery-title": "Études comparative Batterie Virtuelle",
        "virtual-battery-desc":
          "Comparez la rentabilité du contrat EDF OA avec les fournisseurs de batterie virtuelle MyLight Systems, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Études de batterie physique",
        "physical-battery-studies-desc":
          "Ajoutez un modèle de batterie physique et fiche technique pour analyse horaire de l’autoconsommation et de la rentabilité du stockage.",
        "profitability-studies-title":
          "Études technico-financières de rentabilité",
        "profitability-studies-desc":
          "Définissez le business plan du budget. Calcul des prévisionnels financiers sur 25 ans. Analysez le tableau des flux de trésorerie de l’investissement sur la durée de vie du projet.",
        "edf-oa-purchase-tariff-title":
          "Veuille du tarif d’achat EDF OA en métropole et ZNI",
        "edf-oa-purchase-tariff-desc":
          "Les primes d’État et tarifs d’achat de nos études sont mise à jour tous les trimestres avec les nouveaux arrêté tarifaires de la CRE.",
        "purchase-tariff-comparison-title":
          "Comparatif destarifs d’achat par T-0",
        "purchase-tariff-comparison-desc":
          "Comparez la rentabilité des centrales photovoltaïques par rapport aux aides de l’État sur les différents trimestres pour accélérer vos ventes.",
        "credit-financing-simulator-title":
          "Simulateur de crédit et financement",
        "credit-financing-simulator-desc":
          "Analysez l’investissement au comptant, au travers d’un crédit, ou bien de location de toiture - directement intégré dans l’étude.",
        "enedis-costs-simulator-title": "Simulateur des coûts d’Enedis",
        "enedis-costs-simulator-desc":
          "Estimez les coûts de renforcement du réseau électrique à partir du Barème de facturation d’Enedis. La seule alternative au PTF en France.",
        "white-label-support-formats-title":
          "Tous les formats de support en marque blanche",
        "white-label-support-formats-desc":
          "Études en mini-site interactif internet ou PDF ou feuille de calcul ou mobile.",
        "quotes-with-integrated-hardware-title": "Devis avec matériel intégré",
        "quotes-with-integrated-hardware-desc":
          "Préparez vos devis à partir d'une base de données avec milliers de modules, onduleurs, coffrets, batterie.",
        "accounting-numbering-of-quotes-title":
          "Numérotation comptable des devis",
        "accounting-numbering-of-quotes-desc":
          "Personnalisez aussi vos couleurs, vos CGV, fiches techniques, attestation TVA, et bien plus encore de vos devis.",
        "electronic-signature-title": "Signatures électroniques conformes",
        "electronic-signature-desc":
          "Rédigez puis faites signer en ligne vos devis, avec vos références et mentions. Retrouvez vos devis et documents sur votre compte.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Factures comptables pour acomptes et soldes",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Définissez vos acomptes, gérer vos transactions, ajouter vos factures, et bien plus encore.",
        "secure-payments-title":
          "Paiements sécurisés par virement ou carte bancaire",
        "secure-payments-desc":
          "Percevez vos revenus via des pages de paiements simples, avec plusieurs modes de paiement, intégrées aux devis et factures.",
        "product-references-title":
          "10000+ références produits : modules, onduleurs, coffrets, batteries ...",
        "product-references-desc":
          "Choisissez le modèle de produit depuis notre base de données mise à jour en temps réel. Sauvegardez vos kits et listes de matériel pour saisie réduite des devis et démarches.",
        "construction-site-equipment-lists-title":
          "Listes de matériel des chantiers",
        "construction-site-equipment-lists-desc":
          "Planification automatique des listes de produits et équipements pour installations photovoltaïque.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Fiches techniques et Certificats de conformités et Bilan carbone",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Notre base de données contient des milliers de documents à jour pour vos démarches.",
        "professional-technical-documentation-title":
          "Documentation technique professionnelle",
        "professional-technical-documentation-desc":
          "Générez automatiquement des schémas de câblage, Attestations de bridage, et Plans d’exécution.",
        "material-ordering-title": "Commande du matériel",
        "material-ordering-desc":
          "Demandez des devis des fabricants et distributeurs pour trouver des prix compétitifs en ligne.",
        "urban-planning-authorization-requests-title":
          "Demandes d’autorisation d’urbanisme",
        "urban-planning-authorization-requests-desc":
          "La réalisation de la Déclaration Préalable ou Permis de Construire pour votre installation photovoltaïque auprès des institutions locales compétentes pour accord en mairie.",
        "gracious-appeal-title": "Recours gracieux et DAACT",
        "gracious-appeal-desc":
          "La réalisation du DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes. En cas de refus, réalisation du recours gracieux.",
        "architect-communication-title": "Interlocution avec architectes",
        "architect-communication-desc":
          "La réalisation des études de faisabilité de PLU/RNU, préparation des pièces graphiques, de l’attestation architecte, du dépôt en mairie en obligation architecte.",
        "connection-requests-title": "Demandes de raccordement",
        "connection-requests-desc":
          "L’obtention du contrat CAE et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "low-or-medium-voltage-connection-requests-title":
          "Demandes de raccordement en BT ou HTA",
        "low-or-medium-voltage-connection-requests-desc":
          "L’obtention du PTF puis contrat CACS-i et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "collective-self-consumption-connection-requests-title":
          "Demandes de raccordement Autoconsommation Collective",
        "collective-self-consumption-connection-requests-desc":
          "Notre partenaire spécialisé est intégré directement dans votre compte pour création communauté et PMO. Réalisation des demandes CAE et clés de répartition.",
        "consuel-certificate-title":
          "Demandes de visa de l’Attestation Consuel",
        "consuel-certificate-desc":
          "La réalisation du SC144-A ou SC144-B ou SC144-C, la réalisation du Schéma unifilaire électrique, puis dépôt de l’Attestation de conformité Bleu ou Violette (pour batteries).",
        "control-office-title": "Bureau de contrôle et visa Consuel",
        "control-office-desc":
          "L’interlocution technique avec organismes agréés et obtention du rapport DRE de conformité. La réalisation du SC144, Schéma unifilaire électrique, puis dépôt de l’AC Bleu ou Violette.",
        "large-scale-sending-title": "Envoi en 48 heures à grande échelle",
        "large-scale-sending-desc":
          "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
        "real-time-tracking-title": "Suivi daté en temps réel",
        "real-time-tracking-desc":
          "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
        "additional-docs-title":
          "Traitement des demandes de pièces complémentaires",
        "additional-docs-desc":
          "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
        "follow-ups-title": "Relances aux instances administratives",
        "follow-ups-desc":
          "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        "edf-obligation-title": "EDF Obligation Achat",
        "edf-obligation-desc":
          "La réalisation de la démarche auprès d’EDF OA, Attestation sur l’honneur automatique ou bien l’Attestation S21 ‘ENR’ avec Bilan Carbone (au delà de 100 kWc).",
        "virtual-battery-procedure-title": "Démarche Batterie virtuelle",
        "virtual-battery-procedure-desc":
          "La réalisation de la démarche auprès d’un des trois fournisseurs de batterie virtuelle - MyLight Systems, Urban Solar Energy, JPME - pour stockage virtuel.",
        "financing-report-title": "Dossier de rentabilité de financement",
        "financing-report-desc":
          "Analysez le financement de l’investissement photovoltaïque par rapport au rendement énergétique, à partir d’un calcul horaire en kWh.",
        "payment-savings-title": "Calcul de mensualité et effort d’épargne",
        "payment-savings-desc":
          "Comparez le financement de l'investissement photovoltaïque, que ce soit en espèces ou par un prêt bancaire, en intégrant votre OPEX et EBITDA.",
        "solar-subscription-title": "Abonnement solaire",
        "solar-subscription-desc":
          "Notre partenaire spécialisé dans l’abonnement est intégré directement dans votre compte. Faites les demandes de financement par abonnement solaire dès l’étude.",
        "mobile-assistance-title": "Assistance mobile de visite technique",
        "mobile-assistance-desc":
          "Vos technico-commerciaux peuvent facilement renseigner les fiches clients et télécharger les photos et infos en déplacement.",
        "hardware-planning-title": "Planification du matériel",
        "hardware-planning-desc":
          "Listes automatiques d'inventaire des équipements des chantiers disponibles par chantier et par flux, pour contrôle du matériel et des commandes.",
        "integrated-calendar-title": "Agenda intégré",
        "integrated-calendar-desc":
          "Chaque membre de l'équipe a accès, depuis son propre compte, au calendrier de l’entreprise de planification des déplacements et poses. Ajouter Google Calendar ou Microsoft Outlook.",
        "sharing-sites-with-installers-title":
          "Partage des chantiers aux installateurs",
        "sharing-sites-with-installers-desc":
          "Vos documents techniques sont partageables directement depuis votre compte avec vos partenaires maîtres d’œuvres, pour faciliter la construction, Consuel et Bureau de contrôle.",
        "client-relations-title": "Relation client et CRM",
        "client-relations-desc":
          "Attribution de clients, espace commentaires sur fiches clients, stockage de fichiers. Notifications réglables par email automatiques.",
        "team-access-title": "Accès et rôles équipes",
        "team-access-desc":
          "Les commerciaux, le secrétariat et les techniciens peuvent personnaliser chacun leur interface. Les gérants ont accès aux paiements. La comptabilité à accès via email aux factures.",
        "integration-business-referrers-title":
          "Intégration avec les apporteurs d’affaires",
        "integration-business-referrers-desc":
          "Les apporteurs d'affaires n'ont accès qu'à leur clients. La visibilité des informations est personnalisable.",
        "custom-dashboard-title": "Tableau de bord personnalisable",
        "custom-dashboard-desc":
          "Chaque membre de votre équipe peut régler son tableau de bord. Gérez votre dimensionnement, études, démarches administratives, et construction dans un seul endroit.",
        "sales-cycle-tracking-title": "Suivi et rapports du cycle de vente",
        "sales-cycle-tracking-desc":
          "Visualisez les chiffrés clés de vos ventes et votre activité en temps réel. Notre plateforme génère les statistiques de vos chantiers. Recevez des rapports automatiques par email.",
        "data-export-title": "Export des données",
        "data-export-desc":
          "Besoin d’analyser les données sur Excel ? Besoin de sécuriser les données ? Exportez tous les tableaux et dossiers en CSV.",
        "as-built-files-title": "Dossiers Ouvrage Exécutés (DOE) automatiques",
        "as-built-files-desc":
          "Générez les rapports DOE en PDF ou en web, partageables aux clients et tiers pour PV de réception des travaux et audits assurances.",
        "maintenance-contracts-title": "Contrats de maintenance",
        "maintenance-contracts-desc":
          "Aidez vos clients à planifier et payer sur pages de paiement en ligne des interventions de SAV et contrats de maintenance.",
        "white-label-100-title": "100% en marque blanche",
        "white-label-100-desc":
          "Ajoutez votre logo et les couleurs principales, de boutons et des graphiques. Personnalisez les interfaces. Valorisez votre marque.",
        "white-label-client-portal-title": "Portail client en marque blanche",
        "white-label-client-portal-desc":
          "Invitez vos clients à un espace en ligne pour visualiser votre étude, signer votre devis, et suivre l’avancement de leur dossier. Vos clients peuvent renseigner informations et documents.",
        "login-registration-pages-title":
          "Pages de connexion et d’inscription sur site internet",
        "login-registration-pages-desc":
          "Invitez vos clients à se connecter sur leur espace client en marque blanche depuis votre site internet.",
        "seo-title": "Référencement moteur de recherche et SEO",
        "seo-desc":
          "Renseignez le profil personnalisable « Notre établissement » disponible sur études et sur notre annuaire.",
        "online-messaging-title": "Messagerie en ligne",
        "online-messaging-desc":
          "Notre équipe répond dans les minutes qui suivent avec traces écrites.",
        "phone-support-title": "Téléphonie",
        "phone-support-desc":
          "Notre équipe est toujours joignable pour vous accompagner dans vos démarches.",
        "email-title": "Email",
        "email-desc":
          "Notre équipe est disponible par email pour faciliter vos échanges avec les tiers.",
        "video-conference-appointments-title":
          "Rendez-vous en visio-conférence",
        "video-conference-appointments-desc":
          "Notre équipe est à votre écoute pour développer ensemble votre suivi.",
        "file-transfer-title": "Transfert des dossiers",
        "file-transfer-desc":
          "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
      },
    },
    DEVELOPER: {
      hero: {
        "icon-label": "Études de cas",
        "discover-solutions": "Découvrir solutions",
        "book-demo": "Demander une démo",
        "name-orange": "Développeur photovoltaïque",
        "name-black": "en quête de structurer sa croissance",
        description:
          "Vous êtes une société opérant le développement de chantiers en SPV ? Découvrez comment structurer le développement et la construction auprès des acteurs externes.",
      },
      works: {
        heading: "Comment ça marche",
        title:
          "Bureau d’études numérique spécialisé dans le développement solaire en BT et HTA.",
        steps: {
          step1: {
            title: "Ouverture du compte",
            heading:
              "Sans engagement. Inscription rapide et gratuite en ligne. Il suffit ensuite de renseigner les personnes clés de l’entreprise sur le compte.",
          },
          step2: {
            title: "Transfert des dossiers",
            heading:
              "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin de structurer l’opérationnel.",
          },
          step3: {
            title: "Démarrage Comité de Pilotage",
            heading:
              "Organisation du service autour de rapports détaillés et rendez-vous bimensuels avec un seul interlocuteur et des chargés de projets.",
          },
        },
      },
      "product-listing": {
        title: "Solutions tout-en-un et à la carte",
        description:
          "Découvrez la solution de référence de la filière photovoltaïque, reconnue comme N°1 par des centaines de clients.",
        button: "En savoir plus",
        "bi-monthly-steering-committee-title": "Comité de Pilotage bimensuel",
        "bi-monthly-steering-committee-desc":
          "Organisation du service autour de rapports détaillés et rendez-vous tous les 15 jours avec un seul interlocuteur et des chargés de projets.",
        "exclusive-access-title": "Accès privilégié",
        "exclusive-access-desc": "Vos équipes clés sont invités à rejoindre.",
        connection: "Mise en relation",
        "connection-desc":
          "Découvrez des clients potentiels directement depuis votre compte, sans payer de commissions d’apporteurs d’affaires.",
        "project-management-assistance-title":
          "Assistance de maîtrise d’ouvrage",
        "project-management-assistance-desc":
          "Le maître d’œuvre fixe le prix et le matériel. Bénéficiez des outils visite technique et signature électronique pour accélérer vos ventes",
        "3d-sizing-tool-title": "Outil de Dimensionnement en 3D",
        "3d-sizing-tool-desc":
          "Nous avons intégré Aurora Solar pour vous offrir la solution la plus puissante et techniquement précise de productible photovoltaïque.",
        "shading-masks-compliant-with-rge-audit-title":
          "Masques d’ombrages conforme à l’audit RGE",
        "shading-masks-compliant-with-rge-audit-desc":
          "Optez pour la précision du LIDAR au 0,10m en 3D pour réaliser des évaluations de l’ensoleillement au kWh/m² partout en France.",
        "technical-design-pv-syst-title": "Conception technique avec PV SYST",
        "technical-design-pv-syst-desc":
          "Les ingénieurs électriques de notre bureau d’études réalisent la conception des onduleurs et optimisation Pnom, P50-P95 de chantiers.",
        "enedis-api-title": "API Enedis et Données du compteur Linky",
        "enedis-api-desc":
          "Analysez l'autoconsommation électrique de vos clients au travers de leurs historique horaire de consommation en kWh.",
        "self-consumption-title":
          "Études en autoconsommation ou vente en totalité",
        "self-consumption-desc":
          "Proposez des études extraordinaires et complètes, avec nombre illimité de propositions technico-financières par études.",
        "physical-battery-studies-title": "Études de batterie physique",
        "physical-battery-studies-desc":
          "Ajoutez un modèle de batterie physique et fiche technique pour analyse horaire de l’autoconsommation et de la rentabilité du stockage.",
        "profitability-studies-title":
          "Études technico-financières de rentabilité",
        "profitability-studies-desc":
          "Définissez le business plan du budget. Calcul des prévisionnels financiers sur 25 ans. Analysez le tableau des flux de trésorerie de l’investissement sur la durée de vie du projet.",
        "edf-oa-purchase-tariff-title":
          "Veuille du tarif d’achat EDF OA en métropole et ZNI",
        "edf-oa-purchase-tariff-desc":
          "Les primes d’État et tarifs d’achat de nos études sont mise à jour tous les trimestres avec les nouveaux arrêté tarifaires de la CRE.",
        "purchase-tariff-comparison-title":
          "Comparatif destarifs d’achat par T-0",
        "purchase-tariff-comparison-desc":
          "Comparez la rentabilité des centrales photovoltaïques par rapport aux aides de l’État sur les différents trimestres pour accélérer vos ventes.",
        "credit-financing-simulator-title":
          "Simulateur de crédit et financement",
        "credit-financing-simulator-desc":
          "Analysez l’investissement au comptant, au travers d’un crédit, ou bien de location de toiture - directement intégré dans l’étude.",
        "enedis-costs-simulator-title": "Simulateur des coûts d’Enedis",
        "enedis-costs-simulator-desc":
          "Estimez les coûts de renforcement du réseau électrique à partir du Barème de facturation d’Enedis. La seule alternative au PTF en France.",
        "white-label-support-formats-title":
          "Tous les formats de support en marque blanche",
        "white-label-support-formats-desc":
          "Études en mini-site interactif internet ou PDF ou feuille de calcul ou mobile.",
        "quotes-with-integrated-hardware-title": "Devis avec matériel intégré",
        "quotes-with-integrated-hardware-desc":
          "Préparez vos devis à partir d'une base de données avec milliers de modules, onduleurs, coffrets, batterie.",
        "accounting-numbering-of-quotes-title":
          "Numérotation comptable des devis",
        "accounting-numbering-of-quotes-desc":
          "Personnalisez aussi vos couleurs, vos CGV, fiches techniques, attestation TVA, et bien plus encore de vos devis.",
        "electronic-signature-title": "Signatures électroniques conformes",
        "electronic-signature-desc":
          "Rédigez puis faites signer en ligne vos devis, avec vos références et mentions. Retrouvez vos devis et documents sur votre compte.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Factures comptables pour acomptes et soldes",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Définissez vos acomptes, gérer vos transactions, ajouter vos factures, et bien plus encore.",
        "secure-payments-title":
          "Paiements sécurisés par virement ou carte bancaire",
        "secure-payments-desc":
          "Percevez vos revenus via des pages de paiements simples, avec plusieurs modes de paiement, intégrées aux devis et factures.",
        "product-references-title":
          "10000+ références produits : modules, onduleurs, coffrets, batteries ...",
        "product-references-desc":
          "Choisissez le modèle de produit depuis notre base de données mise à jour en temps réel. Sauvegardez vos kits et listes de matériel pour saisie réduite des devis et démarches.",
        "construction-site-equipment-lists-title":
          "Listes de matériel des chantiers",
        "construction-site-equipment-lists-desc":
          "Planification automatique des listes de produits et équipements pour installations photovoltaïque.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Fiches techniques et Certificats de conformités et Bilan carbone",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Notre base de données contient des milliers de documents à jour pour vos démarches.",
        "professional-technical-documentation-title":
          "Documentation technique professionnelle",
        "professional-technical-documentation-desc":
          "Générez automatiquement des schémas de câblage, Attestations de bridage, et Plans d’exécution.",
        "material-ordering-title": "Commande du matériel",
        "material-ordering-desc":
          "Demandez des devis des fabricants et distributeurs pour trouver des prix compétitifs en ligne.",
        "urban-planning-authorization-requests-title":
          "Demandes d’autorisation d’urbanisme",
        "urban-planning-authorization-requests-desc":
          "La réalisation de la Déclaration Préalable ou Permis de Construire pour votre installation photovoltaïque auprès des institutions locales compétentes pour accord en mairie.",
        "architect-communication-title": "Interlocution avec architectes",
        "architect-communication-desc":
          "La réalisation des études de faisabilité de PLU/RNU, préparation des pièces graphiques, de l’attestation architecte, du dépôt en mairie en obligation architecte.",
        "building-permit-expiry-title": "Purge de Permis de construire",
        "building-permit-expiry-desc":
          "La réalisation du DOC, interlocution puis réalisation des Constats huissier, EDDV, puis DAACT pour votre installation photovoltaïque auprès des institutions locales compétentes.",
        "preliminary-declarations-small-land-title":
          "Déclarations préalables ‘Petit sol’",
        "preliminary-declarations-small-land-desc":
          "La réalisation des études de faisabilité de PLU/RNU, réalisation Fiche agricole, Étude de cas par cas, du dépôt en mairie de la Déclaration Préalable.",
        "low-or-medium-voltage-connection-requests-title":
          "Demandes de raccordement en BT ou HTA",
        "low-or-medium-voltage-connection-requests-desc":
          "L’obtention du PTF puis contrat CACS-i et mise en service de votre installation photovoltaïque auprès du gestionnaire électrique du réseau Enedis ou Régie locale ELD.",
        "collective-self-consumption-connection-requests-title":
          "Demandes de raccordement Autoconsommation Collective",
        "collective-self-consumption-connection-requests-desc":
          "Notre partenaire spécialisé est intégré directement dans votre compte pour création communauté et PMO. Réalisation des demandes CAE et clés de répartition.",
        "control-office-title": "Bureau de contrôle et visa Consuel",
        "control-office-desc":
          "L’interlocution technique avec organismes agréés et obtention du rapport DRE de conformité. La réalisation du SC144, Schéma unifilaire électrique, puis dépôt de l’AC Bleu ou Violette.",
        "large-scale-sending-title": "Envoi en 48 heures à grande échelle",
        "large-scale-sending-desc":
          "Nos automatisations pionnières et robots génèrent les documents et remplissent les formulaires en ligne.",
        "real-time-tracking-title": "Suivi daté en temps réel",
        "real-time-tracking-desc":
          "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
        "additional-docs-title":
          "Traitement des demandes de pièces complémentaires",
        "additional-docs-desc":
          "Notre bureau d’études traite les demandes de pièces complémentaires pour débloquer les dossiers.",
        "follow-ups-title": "Relances aux instances administratives",
        "follow-ups-desc":
          "Nos chargés de projets relancent les instances administratives pour réduire les délais d’instruction.",
        "edf-obligation-title": "EDF Obligation Achat",
        "edf-obligation-desc":
          "La réalisation de la démarche auprès d’EDF OA, Attestation sur l’honneur automatique ou bien l’Attestation S21 ‘ENR’ avec Bilan Carbone (au delà de 100 kWc).",
        "arpe-procedure-title": "Démarche ARPE",
        "arpe-procedure-desc":
          "La réalisation de la démarche auprès d’un acheteur alternatif - Octopus Energie, Ekwateur, etc. - pour contrats PPE et autres contrats d’achat.",
        "financing-report-title": "Dossier de rentabilité de financement",
        "financing-report-desc":
          "Analysez le financement de l’investissement photovoltaïque par rapport au rendement énergétique, à partir d’un calcul horaire en kWh.",
        "payment-savings-title": "Calcul de mensualité et effort d’épargne",
        "payment-savings-desc":
          "Comparez le financement de l'investissement photovoltaïque, que ce soit en espèces ou par un prêt bancaire, en intégrant votre OPEX et EBITDA.",
        "cost-price-buyout-profitability-calculation-title":
          "Calcul du coût de revient et soulte et rentabilité",
        "cost-price-buyout-profitability-calculation-desc":
          "Analysez le financement de l’investissement photovoltaïque et le loyer, en intégrant votre OPEX et votre TRI",
        "creation-and-management-of-spvs-title": "Création et gestion des SPV",
        "creation-and-management-of-spvs-desc":
          "Votre équipe organise les portefeuilles de chantiers par SPV directement depuis votre compte. Nos chargés de projets peuvent créer les SIRET et accompagner auprès des notaires.",
        "mobile-assistance-title": "Assistance mobile de visite technique",
        "mobile-assistance-desc":
          "Vos technico-commerciaux peuvent facilement renseigner les fiches clients et télécharger les photos et infos en déplacement.",
        "hardware-planning-title": "Planification du matériel",
        "hardware-planning-desc":
          "Listes automatiques d'inventaire des équipements des chantiers disponibles par chantier et par flux, pour contrôle du matériel et des commandes.",
        "integrated-calendar-title": "Agenda intégré",
        "integrated-calendar-desc":
          "Chaque membre de l'équipe a accès, depuis son propre compte, au calendrier de l’entreprise de planification des déplacements et poses. Ajouter Google Calendar ou Microsoft Outlook.",
        "sharing-sites-with-installers-title":
          "Partage des chantiers aux installateurs",
        "sharing-sites-with-installers-desc":
          "Vos documents techniques sont partageables directement depuis votre compte avec vos partenaires maîtres d’œuvres, pour faciliter la construction, Consuel et Bureau de contrôle.",
        "sharing-files-with-third-parties-title":
          "Partage des dossiers aux tiers",
        "sharing-files-with-third-parties-desc":
          "Vos documents administratifs sont partageables directement depuis votre compte aux tiers que vous autorisés, dans le cadre d’audits pour tiers investissement.",
        "client-relations-title": "Relation client et CRM",
        "client-relations-desc":
          "Attribution de clients, espace commentaires sur fiches clients, stockage de fichiers. Notifications réglables par email automatiques.",
        "team-access-title": "Accès et rôles équipes",
        "team-access-desc":
          "Les commerciaux, le secrétariat et les techniciens peuvent personnaliser chacun leur interface. Les gérants ont accès aux paiements. La comptabilité à accès via email aux factures.",
        "integration-business-referrers-title":
          "Intégration avec les apporteurs d’affaires",
        "integration-business-referrers-desc":
          "Les apporteurs d'affaires n'ont accès qu'à leur clients. La visibilité des informations est personnalisable.",
        "custom-dashboard-title": "Tableau de bord personnalisable",
        "custom-dashboard-desc":
          "Chaque membre de votre équipe peut régler son tableau de bord. Gérez votre dimensionnement, études, démarches administratives, et construction dans un seul endroit.",
        "sales-cycle-tracking-title": "Suivi et rapports du cycle de vente",
        "sales-cycle-tracking-desc":
          "Visualisez les chiffrés clés de vos ventes et votre activité en temps réel. Notre plateforme génère les statistiques de vos chantiers. Recevez des rapports automatiques par email.",
        "data-export-title": "Export des données",
        "data-export-desc":
          "Besoin d’analyser les données sur Excel ? Besoin de sécuriser les données ? Exportez tous les tableaux et dossiers en CSV.",
        "as-built-files-title": "Dossiers Ouvrage Exécutés (DOE) automatiques",
        "as-built-files-desc":
          "Générez les rapports DOE en PDF ou en web, partageables aux clients et tiers pour PV de réception des travaux et audits assurances.",
        "maintenance-contracts-title": "Contrats de maintenance",
        "maintenance-contracts-desc":
          "Aidez vos clients à planifier et payer sur pages de paiement en ligne des interventions de SAV et contrats de maintenance.",
        "white-label-100-title": "100% en marque blanche",
        "white-label-100-desc":
          "Ajoutez votre logo et les couleurs principales, de boutons et des graphiques. Personnalisez les interfaces. Valorisez votre marque.",
        "white-label-client-portal-title": "Portail client en marque blanche",
        "white-label-client-portal-desc":
          "Invitez vos clients à un espace en ligne pour visualiser votre étude, signer votre devis, et suivre l’avancement de leur dossier. Vos clients peuvent renseigner informations et documents.",
        "login-registration-pages-title":
          "Pages de connexion et d’inscription sur site internet",
        "login-registration-pages-desc":
          "Invitez vos clients à se connecter sur leur espace client en marque blanche depuis votre site internet.",
        "seo-title": "Référencement moteur de recherche et SEO",
        "seo-desc":
          "Renseignez le profil personnalisable « Notre établissement » disponible sur études et sur notre annuaire.",
        "online-messaging-title": "Messagerie en ligne",
        "online-messaging-desc":
          "Notre équipe répond dans les minutes qui suivent avec traces écrites.",
        "phone-support-title": "Téléphonie",
        "phone-support-desc":
          "Notre équipe est toujours joignable pour vous accompagner dans vos démarches.",
        "email-title": "Email",
        "email-desc":
          "Notre équipe est disponible par email pour faciliter vos échanges avec les tiers.",
        "video-conference-appointments-title":
          "Rendez-vous en visio-conférence",
        "video-conference-appointments-desc":
          "Notre équipe est à votre écoute pour développer ensemble votre suivi.",
        "file-transfer-title": "Transfert des dossiers",
        "file-transfer-desc":
          "Nos équipes informatiques vous accompagnent pour migrer les données et dossiers sur notre système afin que vous puissiez piloter l’opérationnel.",
      },
    },
    landing: {
      title: "Solution tout-en-un pour votre activité solaire",
      description:
        "Découvrez comment projetsolaire.com est utilisé par nos centaines de clients pour développer leur activité.",
      "discover-solutions": "Découvrir solutions",
      "learn-more": "En savoir plus",
      "service-client-360": "Service client 360°",
      "service-client-360-desc":
        "Gardez le contrôle avec notre service client multi-canal et disponible toute l’année.",
      heading: {
        artisan: "Artisan Solaire",
        regional: "PME Locale",
        national: "Acteur National",
        franchise: "Franchises",
        developer: "Développeur",
        "plug-and-play": "DIY & Plug & Play",
      },
    },
  },
  header: {
    "buy-hardware": "Achat Matériel",
    "use-cases": {
      title: "Études de cas",
      label: "Études de cas",
      description:
        "Découvrez comment projetsolaire.com est utilisé par nos centaines de clients pour développer leur activité.",
      "description-2":
        "Découvrez les entreprises qui utilisent déjà nos solutions. Ce sont eux qui en parlent le mieux !",
      artisan: {
        name: "Artisan solaire",
        description: "installateur photovoltaïque de proximité.",
      },
      "pme-locale": {
        name: "PME locale",
        description:
          "installateur photovoltaïque opérant dans plusieurs départements.",
      },
      national: {
        name: "Acteur national",
        description:
          "acteur intervenant dans toute la France et réalisant de nombreux chantiers à l’échelle nationale.",
      },
      "plug-and-play": {
        name: "Kits DIY et plug & play",
        description:
          "marque proposant une solution plug & play (kit solaire) ou DIY (Do It Yourself) à travers la France.",
      },
      franchise: {
        name: "Réseau de franchises",
        description:
          "société opérant en franchise sur l’ensemble du territoire national, intéressé par les chantiers du réseau de franchises.",
      },
      developer: {
        name: "Développeur photovoltaïque",
        description: "société opérant le développement de chantiers en SPV.",
      },
      button: {
        title: "Témoignages clients",
        "sub-title": "Déjà 900 clients !",
      },
    },
    products: {
      title: "Solutions à la carte",
      label: "Solutions",
      description:
        "Découvrez la solution tout-en-un destinée aux professionnels pour optimiser chaque étape de l'installation photovoltaïque.",
      "description-2":
        "Découvrez les entreprises qui utilisent déjà nos solutions. Ce sont eux qui en parlent le mieux !",
      sizing: {
        "product-name": "Dimensionnement Solaire",
        description: "Calepinage en 3D avec masques d'ombres.",
      },
      studies: {
        "product-name": "Études Photovoltaïques",
        description: "Analyse horaire sur 25 ans de dimensionnement.",
      },
      qtv: {
        "product-name": "Devis et App Visite Technique",
        description:
          "Checklist, devis, signature électronique, factures, paiements en ligne.",
      },
      procedures: {
        "product-name": "Démarches Administratives",
        description:
          "Gestion de l'Urbanisme, Enedis, Consuel, EDF OA, et plus.",
      },
      stock: {
        "product-name": "Stocks et Matériel",
        description: "Références produits, listes de matériel, commandes.",
      },
      management: {
        "product-name": "Gestion de Chantiers",
        description:
          "Accès et rôles équipes, agenda intégré, partage aux tiers.",
      },
      "find-new-clients": {
        title: "Recevez des chantiers, envoyez vos devis",
        description:
          "Découvrez un modèle économique innovant d'assistance de maîtrise d'ouvrage.",
      },
      button: {
        title: "Témoignages clients",
        "sub-title": "Déjà 900 clients !",
      },
    },
  },
}
